// list of ISO 3166-1 alpha-2 country codes
export enum CountryShortCodes {
  'Afghanistan' = 'af',
  'Åland Islands' = 'ax',
  'Albania' = 'al',
  'Algeria' = 'dz',
  'American Samoa' = 'as',
  'Andorra' = 'ad',
  'Angola' = 'ao',
  'Anguilla' = 'ai',
  'Antarctica' = 'aq',
  'Antigua and Barbuda' = 'ag',
  'Argentina' = 'ar',
  'Armenia' = 'am',
  'Aruba' = 'aw',
  'Australia' = 'au',
  'Austria' = 'at',
  'Azerbaijan' = 'az',
  'Bahamas' = 'bs',
  'Bahrain' = 'bh',
  'Bangladesh' = 'bd',
  'Barbados' = 'bb',
  'Belarus' = 'by',
  'Belgium' = 'be',
  'Belize' = 'bz',
  'Benin' = 'bj',
  'Bermuda' = 'bm',
  'Bhutan' = 'bt',
  'Bolivia (Plurinational State of)' = 'bo',
  'Bonaire, Sint Eustatius and Saba' = 'bq',
  'Bosnia and Herzegovina' = 'ba',
  'Botswana' = 'bw',
  'Bouvet Island' = 'bv',
  'Brazil' = 'br',
  'British Indian Ocean Territory' = 'io',
  'Brunei Darussalam' = 'bn',
  'Bulgaria' = 'bg',
  'Burkina Faso' = 'bf',
  'Burundi' = 'bi',
  'Cabo Verde' = 'cv',
  'Cambodia' = 'kh',
  'Cameroon' = 'cm',
  'Canada' = 'ca',
  'Cayman Islands' = 'ky',
  'Central African Republic' = 'cf',
  'Chad' = 'td',
  'Chile' = 'cl',
  'China' = 'cn',
  'Christmas Island' = 'cx',
  'Cocos (Keeling) Islands' = 'cc',
  'Colombia' = 'co',
  'Comoros' = 'km',
  'Congo' = 'cg',
  'Congo, Democratic Republic of the' = 'cd',
  'Cook Islands' = 'ck',
  'Costa Rica' = 'cr',
  "Côte d'Ivoire" = 'ci',
  'Croatia' = 'hr',
  'Cuba' = 'cu',
  'Curaçao' = 'cw',
  'Cyprus' = 'cy',
  'Czechia' = 'cz',
  'Denmark' = 'dk',
  'Djibouti' = 'dj',
  'Dominica' = 'dm',
  'Dominican Republic' = 'do',
  'Ecuador' = 'ec',
  'Egypt' = 'eg',
  'El Salvador' = 'sv',
  'Equatorial Guinea' = 'gq',
  'Eritrea' = 'er',
  'Estonia' = 'ee',
  'Eswatini' = 'sz',
  'Ethiopia' = 'et',
  'Falkland Islands (Malvinas)' = 'fk',
  'Faroe Islands' = 'fo',
  'Fiji' = 'fj',
  'Finland' = 'fi',
  'France' = 'fr',
  'French Guiana' = 'gf',
  'French Polynesia' = 'pf',
  'French Southern Territories' = 'tf',
  'Gabon' = 'ga',
  'Gambia' = 'gm',
  'Georgia' = 'ge',
  'Germany' = 'de',
  'Ghana' = 'gh',
  'Gibraltar' = 'gi',
  'Greece' = 'gr',
  'Greenland' = 'gl',
  'Grenada' = 'gd',
  'Guadeloupe' = 'gp',
  'Guam' = 'gu',
  'Guatemala' = 'gt',
  'Guernsey' = 'gg',
  'Guinea' = 'gn',
  'Guinea-Bissau' = 'gw',
  'Guyana' = 'gy',
  'Haiti' = 'ht',
  'Heard Island and McDonald Islands' = 'hm',
  'Holy See' = 'va',
  'Honduras' = 'hn',
  'Hong Kong' = 'hk',
  'Hungary' = 'hu',
  'Iceland' = 'is',
  'India' = 'in',
  'Indonesia' = 'id',
  'Iran (Islamic Republic of)' = 'ir',
  'Iraq' = 'iq',
  'Ireland' = 'ie',
  'Isle of Man' = 'im',
  'Israel' = 'il',
  'Italy' = 'it',
  'Jamaica' = 'jm',
  'Japan' = 'jp',
  'Jersey' = 'je',
  'Jordan' = 'jo',
  'Kazakhstan' = 'kz',
  'Kenya' = 'ke',
  'Kiribati' = 'ki',
  "Korea (Democratic People's Republic of)" = 'kp',
  'South Korea' = 'kr',
  'Kuwait' = 'kw',
  'Kyrgyzstan' = 'kg',
  "Lao People's Democratic Republic" = 'la',
  'Latvia' = 'lv',
  'Lebanon' = 'lb',
  'Lesotho' = 'ls',
  'Liberia' = 'lr',
  'Libya' = 'ly',
  'Liechtenstein' = 'li',
  'Lithuania' = 'lt',
  'Luxembourg' = 'lu',
  'Macao' = 'mo',
  'Madagascar' = 'mg',
  'Malawi' = 'mw',
  'Malaysia' = 'my',
  'Maldives' = 'mv',
  'Mali' = 'ml',
  'Malta' = 'mt',
  'Marshall Islands' = 'mh',
  'Martinique' = 'mq',
  'Mauritania' = 'mr',
  'Mauritius' = 'mu',
  'Mayotte' = 'yt',
  'Mexico' = 'mx',
  'Micronesia (Federated States of)' = 'fm',
  'Moldova, Republic of' = 'md',
  'Monaco' = 'mc',
  'Mongolia' = 'mn',
  'Montenegro' = 'me',
  'Montserrat' = 'ms',
  'Morocco' = 'ma',
  'Mozambique' = 'mz',
  'Myanmar' = 'mm',
  'Namibia' = 'na',
  'Nauru' = 'nr',
  'Nepal' = 'np',
  'Netherlands' = 'nl',
  'New Caledonia' = 'nc',
  'New Zealand' = 'nz',
  'Nicaragua' = 'ni',
  'Niger' = 'ne',
  'Nigeria' = 'ng',
  'Niue' = 'nu',
  'Norfolk Island' = 'nf',
  'North Macedonia' = 'mk',
  'Northern Mariana Islands' = 'mp',
  'Norway' = 'no',
  'Oman' = 'om',
  'Pakistan' = 'pk',
  'Palau' = 'pw',
  'Palestine, State of' = 'ps',
  'Panama' = 'pa',
  'Papua New Guinea' = 'pg',
  'Paraguay' = 'py',
  'Peru' = 'pe',
  'Philippines' = 'ph',
  'Pitcairn' = 'pn',
  'Poland' = 'pl',
  'Portugal' = 'pt',
  'Puerto Rico' = 'pr',
  'Qatar' = 'qa',
  'Réunion' = 're',
  'Romania' = 'ro',
  'Russian Federation' = 'ru',
  'Rwanda' = 'rw',
  'Saint Barthélemy' = 'bl',
  'Saint Helena, Ascension and Tristan da Cunha' = 'sh',
  'Saint Kitts and Nevis' = 'kn',
  'Saint Lucia' = 'lc',
  'Saint Martin (French part)' = 'mf',
  'Saint Pierre and Miquelon' = 'pm',
  'Saint Vincent and the Grenadines' = 'vc',
  'Samoa' = 'ws',
  'San Marino' = 'sm',
  'Sao Tome and Principe' = 'st',
  'Saudi Arabia' = 'sa',
  'Senegal' = 'sn',
  'Serbia' = 'rs',
  'Seychelles' = 'sc',
  'Sierra Leone' = 'sl',
  'Singapore' = 'sg',
  'Sint Maarten (Dutch part)' = 'sx',
  'Slovakia' = 'sk',
  'Slovenia' = 'si',
  'Solomon Islands' = 'sb',
  'Somalia' = 'so',
  'South Africa' = 'za',
  'South Georgia and the South Sandwich Islands' = 'gs',
  'South Sudan' = 'ss',
  'Spain' = 'es',
  'Sri Lanka' = 'lk',
  'Sudan' = 'sd',
  'Suriname' = 'sr',
  'Svalbard and Jan Mayen' = 'sj',
  'Sweden' = 'se',
  'Switzerland' = 'ch',
  'Syrian Arab Republic' = 'sy',
  'Taiwan, Province of China' = 'tw',
  'Tajikistan' = 'tj',
  'Tanzania, United Republic of' = 'tz',
  'Thailand' = 'th',
  'Timor-Leste' = 'tl',
  'Togo' = 'tg',
  'Tokelau' = 'tk',
  'Tonga' = 'to',
  'Trinidad and Tobago' = 'tt',
  'Tunisia' = 'tn',
  'Turkey' = 'tr',
  'Turkmenistan' = 'tm',
  'Turks and Caicos Islands' = 'tc',
  'Tuvalu' = 'tv',
  'Uganda' = 'ug',
  'Ukraine' = 'ua',
  'United Arab Emirates' = 'ae',
  'United Kingdom of Great Britain and Northern Ireland' = 'gb',
  'United States of America' = 'us',
  'United States Minor Outlying Islands' = 'um',
  'Uruguay' = 'uy',
  'Uzbekistan' = 'uz',
  'Vanuatu' = 'vu',
  'Venezuela (Bolivarian Republic of)' = 've',
  'Viet Nam' = 'vn',
  'Virgin Islands (British)' = 'vg',
  'Virgin Islands (U.S.)' = 'vi',
  'Wallis and Futuna' = 'wf',
  'Western Sahara' = 'eh',
  'Yemen' = 'ye',
  'Zambia' = 'zm',
  'Zimbabwe' = 'zw',
}

export const generalCountriesData = [
  {
    alpha2: 'AC',
    alpha3: '',
    countryCallingCodes: ['+247'],
    currencies: ['USD'],
    ioc: 'SHP',
    languages: ['eng'],
    name: 'Ascension Island',
    status: 'reserved',
  },
  {
    alpha2: 'AD',
    alpha3: 'AND',
    countryCallingCodes: ['+376'],
    currencies: ['EUR'],
    ioc: 'AND',
    languages: ['cat'],
    name: 'Andorra',
    status: 'assigned',
  },
  {
    alpha2: 'AE',
    alpha3: 'ARE',
    countryCallingCodes: ['+971'],
    currencies: ['AED'],
    ioc: 'UAE',
    languages: ['ara'],
    name: 'United Arab Emirates',
    status: 'assigned',
  },
  {
    alpha2: 'AF',
    alpha3: 'AFG',
    countryCallingCodes: ['+93'],
    currencies: ['AFN'],
    ioc: 'AFG',
    languages: ['pus'],
    name: 'Afghanistan',
    status: 'assigned',
  },
  {
    alpha2: 'AG',
    alpha3: 'ATG',
    countryCallingCodes: ['+1 268'],
    currencies: ['XCD'],
    ioc: 'ANT',
    languages: ['eng'],
    name: 'Antigua And Barbuda',
    status: 'assigned',
  },
  {
    alpha2: 'AI',
    alpha3: 'AIA',
    countryCallingCodes: ['+1 264'],
    currencies: ['XCD'],
    ioc: '',
    languages: ['eng'],
    name: 'Anguilla',
    status: 'assigned',
  },
  {
    alpha2: 'AL',
    alpha3: 'ALB',
    countryCallingCodes: ['+355'],
    currencies: ['ALL'],
    ioc: 'ALB',
    languages: ['alb'],
    name: 'Albania',
    status: 'assigned',
  },
  {
    alpha2: 'AM',
    alpha3: 'ARM',
    countryCallingCodes: ['+374'],
    currencies: ['AMD'],
    ioc: 'ARM',
    languages: ['arm', 'rus'],
    name: 'Armenia',
    status: 'assigned',
  },
  {
    alpha2: 'AO',
    alpha3: 'AGO',
    countryCallingCodes: ['+244'],
    currencies: ['AOA'],
    ioc: 'ANG',
    languages: ['por'],
    name: 'Angola',
    status: 'assigned',
  },
  {
    alpha2: 'AQ',
    alpha3: 'ATA',
    countryCallingCodes: ['+672'],
    currencies: [],
    ioc: '',
    languages: [],
    name: 'Antarctica',
    status: 'assigned',
  },
  {
    alpha2: 'AR',
    alpha3: 'ARG',
    countryCallingCodes: ['+54'],
    currencies: ['ARS'],
    ioc: 'ARG',
    languages: ['spa'],
    name: 'Argentina',
    status: 'assigned',
  },
  {
    alpha2: 'AS',
    alpha3: 'ASM',
    countryCallingCodes: ['+1 684'],
    currencies: ['USD'],
    ioc: 'ASA',
    languages: ['eng', 'smo'],
    name: 'American Samoa',
    status: 'assigned',
  },
  {
    alpha2: 'AT',
    alpha3: 'AUT',
    countryCallingCodes: ['+43'],
    currencies: ['EUR'],
    ioc: 'AUT',
    languages: ['ger'],
    name: 'Austria',
    status: 'assigned',
  },
  {
    alpha2: 'AU',
    alpha3: 'AUS',
    countryCallingCodes: ['+61'],
    currencies: ['AUD'],
    ioc: 'AUS',
    languages: ['eng'],
    name: 'Australia',
    status: 'assigned',
  },
  {
    alpha2: 'AW',
    alpha3: 'ABW',
    countryCallingCodes: ['+297'],
    currencies: ['AWG'],
    ioc: 'ARU',
    languages: ['dut'],
    name: 'Aruba',
    status: 'assigned',
  },
  {
    alpha2: 'AX',
    alpha3: 'ALA',
    countryCallingCodes: ['+358'],
    currencies: ['EUR'],
    ioc: '',
    languages: ['swe'],
    name: 'Åland Islands',
    status: 'assigned',
  },
  {
    alpha2: 'AZ',
    alpha3: 'AZE',
    countryCallingCodes: ['+994'],
    currencies: ['AZN'],
    ioc: 'AZE',
    languages: ['aze'],
    name: 'Azerbaijan',
    status: 'assigned',
  },
  {
    alpha2: 'BA',
    alpha3: 'BIH',
    countryCallingCodes: ['+387'],
    currencies: ['BAM'],
    ioc: 'BIH',
    languages: ['bos', 'cre', 'srp'],
    name: 'Bosnia & Herzegovina',
    status: 'assigned',
  },
  {
    alpha2: 'BB',
    alpha3: 'BRB',
    countryCallingCodes: ['+1 246'],
    currencies: ['BBD'],
    ioc: 'BAR',
    languages: ['eng'],
    name: 'Barbados',
    status: 'assigned',
  },
  {
    alpha2: 'BD',
    alpha3: 'BGD',
    countryCallingCodes: ['+880'],
    currencies: ['BDT'],
    ioc: 'BAN',
    languages: ['ben'],
    name: 'Bangladesh',
    status: 'assigned',
  },
  {
    alpha2: 'BE',
    alpha3: 'BEL',
    countryCallingCodes: ['+32'],
    currencies: ['EUR'],
    ioc: 'BEL',
    languages: ['dut', 'fre', 'ger'],
    name: 'Belgium',
    status: 'assigned',
  },
  {
    alpha2: 'BF',
    alpha3: 'BFA',
    countryCallingCodes: ['+226'],
    currencies: ['XOF'],
    ioc: 'BUR',
    languages: ['fre'],
    name: 'Burkina Faso',
    status: 'assigned',
  },
  {
    alpha2: 'BG',
    alpha3: 'BGR',
    countryCallingCodes: ['+359'],
    currencies: ['BGN'],
    ioc: 'BUL',
    languages: ['bul'],
    name: 'Bulgaria',
    status: 'assigned',
  },
  {
    alpha2: 'BH',
    alpha3: 'BHR',
    countryCallingCodes: ['+973'],
    currencies: ['BHD'],
    ioc: 'BRN',
    languages: ['ara'],
    name: 'Bahrain',
    status: 'assigned',
  },
  {
    alpha2: 'BI',
    alpha3: 'BDI',
    countryCallingCodes: ['+257'],
    currencies: ['BIF'],
    ioc: 'BDI',
    languages: ['fre'],
    name: 'Burundi',
    status: 'assigned',
  },
  {
    alpha2: 'BJ',
    alpha3: 'BEN',
    countryCallingCodes: ['+229'],
    currencies: ['XOF'],
    ioc: 'BEN',
    languages: ['fre'],
    name: 'Benin',
    status: 'assigned',
  },
  {
    alpha2: 'BL',
    alpha3: 'BLM',
    countryCallingCodes: ['+590'],
    currencies: ['EUR'],
    ioc: '',
    languages: ['fre'],
    name: 'Saint Barthélemy',
    status: 'assigned',
  },
  {
    alpha2: 'BM',
    alpha3: 'BMU',
    countryCallingCodes: ['+1 441'],
    currencies: ['BMD'],
    ioc: 'BER',
    languages: ['eng'],
    name: 'Bermuda',
    status: 'assigned',
  },
  {
    alpha2: 'BN',
    alpha3: 'BRN',
    countryCallingCodes: ['+673'],
    currencies: ['BND'],
    ioc: 'BRU',
    languages: ['may', 'eng'],
    name: 'Brunei Darussalam',
    status: 'assigned',
  },
  {
    alpha2: 'BO',
    alpha3: 'BOL',
    countryCallingCodes: ['+591'],
    currencies: ['BOB', 'BOV'],
    ioc: 'BOL',
    languages: ['spa', 'aym', 'que'],
    name: 'Bolivia, Plurinational State Of',
    status: 'assigned',
  },
  {
    alpha2: 'BQ',
    alpha3: 'BES',
    countryCallingCodes: ['+599'],
    currencies: ['USD'],
    ioc: '',
    languages: ['dut'],
    name: 'Bonaire, Saint Eustatius And Saba',
    status: 'assigned',
  },
  {
    alpha2: 'BR',
    alpha3: 'BRA',
    countryCallingCodes: ['+55'],
    currencies: ['BRL'],
    ioc: 'BRA',
    languages: ['por'],
    name: 'Brazil',
    status: 'assigned',
  },
  {
    alpha2: 'BS',
    alpha3: 'BHS',
    countryCallingCodes: ['+1 242'],
    currencies: ['BSD'],
    ioc: 'BAH',
    languages: ['eng'],
    name: 'Bahamas',
    status: 'assigned',
  },
  {
    alpha2: 'BT',
    alpha3: 'BTN',
    countryCallingCodes: ['+975'],
    currencies: ['INR', 'BTN'],
    ioc: 'BHU',
    languages: ['dzo'],
    name: 'Bhutan',
    status: 'assigned',
  },
  {
    alpha2: 'BV',
    alpha3: 'BVT',
    countryCallingCodes: [],
    currencies: ['NOK'],
    ioc: '',
    languages: [],
    name: 'Bouvet Island',
    status: 'assigned',
  },
  {
    alpha2: 'BW',
    alpha3: 'BWA',
    countryCallingCodes: ['+267'],
    currencies: ['BWP'],
    ioc: 'BOT',
    languages: ['eng', 'tsn'],
    name: 'Botswana',
    status: 'assigned',
  },
  {
    alpha2: 'BY',
    alpha3: 'BLR',
    countryCallingCodes: ['+375'],
    currencies: ['BYR'],
    ioc: 'BLR',
    languages: ['bel', 'rus'],
    name: 'Belarus',
    status: 'assigned',
  },
  {
    alpha2: 'BZ',
    alpha3: 'BLZ',
    countryCallingCodes: ['+501'],
    currencies: ['BZD'],
    ioc: 'BIZ',
    languages: ['eng'],
    name: 'Belize',
    status: 'assigned',
  },
  {
    alpha2: 'CA',
    alpha3: 'CAN',
    countryCallingCodes: ['+1'],
    currencies: ['CAD'],
    ioc: 'CAN',
    languages: ['eng', 'fre'],
    name: 'Canada',
    status: 'assigned',
  },
  {
    alpha2: 'CC',
    alpha3: 'CCK',
    countryCallingCodes: ['+61'],
    currencies: ['AUD'],
    ioc: '',
    languages: ['eng'],
    name: 'Cocos (Keeling) Islands',
    status: 'assigned',
  },
  {
    alpha2: 'CD',
    alpha3: 'COD',
    countryCallingCodes: ['+243'],
    currencies: ['CDF'],
    ioc: 'COD',
    languages: ['fre', 'lin', 'kon', 'swa'],
    name: 'Democratic Republic Of Congo',
    status: 'assigned',
  },
  {
    alpha2: 'CF',
    alpha3: 'CAF',
    countryCallingCodes: ['+236'],
    currencies: ['XAF'],
    ioc: 'CAF',
    languages: ['fre', 'sag'],
    name: 'Central African Republic',
    status: 'assigned',
  },
  {
    alpha2: 'CG',
    alpha3: 'COG',
    countryCallingCodes: ['+242'],
    currencies: ['XAF'],
    ioc: 'CGO',
    languages: ['fre', 'lin'],
    name: 'Republic Of Congo',
    status: 'assigned',
  },
  {
    alpha2: 'CH',
    alpha3: 'CHE',
    countryCallingCodes: ['+41'],
    currencies: ['CHF', 'CHE', 'CHW'],
    ioc: 'SUI',
    languages: ['ger', 'fre', 'ita', 'roh'],
    name: 'Switzerland',
    status: 'assigned',
  },
  {
    alpha2: 'CI',
    alpha3: 'CIV',
    countryCallingCodes: ['+225'],
    currencies: ['XOF'],
    ioc: 'CIV',
    languages: ['fre'],
    name: "Cote d'Ivoire",
    status: 'assigned',
  },
  {
    alpha2: 'CK',
    alpha3: 'COK',
    countryCallingCodes: ['+682'],
    currencies: ['NZD'],
    ioc: 'COK',
    languages: ['eng', 'mao'],
    name: 'Cook Islands',
    status: 'assigned',
  },
  {
    alpha2: 'CL',
    alpha3: 'CHL',
    countryCallingCodes: ['+56'],
    currencies: ['CLP', 'CLF'],
    ioc: 'CHI',
    languages: ['spa'],
    name: 'Chile',
    status: 'assigned',
  },
  {
    alpha2: 'CM',
    alpha3: 'CMR',
    countryCallingCodes: ['+237'],
    currencies: ['XAF'],
    ioc: 'CMR',
    languages: ['eng', 'fre'],
    name: 'Cameroon',
    status: 'assigned',
  },
  {
    alpha2: 'CN',
    alpha3: 'CHN',
    countryCallingCodes: ['+86'],
    currencies: ['CNY'],
    ioc: 'CHN',
    languages: ['chi'],
    name: 'China',
    status: 'assigned',
  },
  {
    alpha2: 'CO',
    alpha3: 'COL',
    countryCallingCodes: ['+57'],
    currencies: ['COP', 'COU'],
    ioc: 'COL',
    languages: ['spa'],
    name: 'Colombia',
    status: 'assigned',
  },
  {
    alpha2: 'CP',
    alpha3: '',
    countryCallingCodes: [],
    currencies: ['EUR'],
    ioc: '',
    languages: [],
    name: 'Clipperton Island',
    status: 'reserved',
  },
  {
    alpha2: 'CR',
    alpha3: 'CRI',
    countryCallingCodes: ['+506'],
    currencies: ['CRC'],
    ioc: 'CRC',
    languages: ['spa'],
    name: 'Costa Rica',
    status: 'assigned',
  },
  {
    alpha2: 'CU',
    alpha3: 'CUB',
    countryCallingCodes: ['+53'],
    currencies: ['CUP', 'CUC'],
    ioc: 'CUB',
    languages: ['spa'],
    name: 'Cuba',
    status: 'assigned',
  },
  {
    alpha2: 'CV',
    alpha3: 'CPV',
    countryCallingCodes: ['+238'],
    currencies: ['CVE'],
    ioc: 'CPV',
    languages: ['por'],
    name: 'Cabo Verde',
    status: 'assigned',
  },
  {
    alpha2: 'CW',
    alpha3: 'CUW',
    countryCallingCodes: ['+599'],
    currencies: ['ANG'],
    ioc: '',
    languages: ['dut'],
    name: 'Curacao',
    status: 'assigned',
  },
  {
    alpha2: 'CX',
    alpha3: 'CXR',
    countryCallingCodes: ['+61'],
    currencies: ['AUD'],
    ioc: '',
    languages: ['eng'],
    name: 'Christmas Island',
    status: 'assigned',
  },
  {
    alpha2: 'CY',
    alpha3: 'CYP',
    countryCallingCodes: ['+357'],
    currencies: ['EUR'],
    ioc: 'CYP',
    languages: ['gre', 'tur'],
    name: 'Cyprus',
    status: 'assigned',
  },
  {
    alpha2: 'CZ',
    alpha3: 'CZE',
    countryCallingCodes: ['+420'],
    currencies: ['CZK'],
    ioc: 'CZE',
    languages: ['cze'],
    name: 'Czech Republic',
    status: 'assigned',
  },
  {
    alpha2: 'DE',
    alpha3: 'DEU',
    countryCallingCodes: ['+49'],
    currencies: ['EUR'],
    ioc: 'GER',
    languages: ['ger'],
    name: 'Germany',
    status: 'assigned',
  },
  {
    alpha2: 'DG',
    alpha3: '',
    countryCallingCodes: [],
    currencies: ['USD'],
    ioc: '',
    languages: [],
    name: 'Diego Garcia',
    status: 'reserved',
  },
  {
    alpha2: 'DJ',
    alpha3: 'DJI',
    countryCallingCodes: ['+253'],
    currencies: ['DJF'],
    ioc: 'DJI',
    languages: ['ara', 'fre'],
    name: 'Djibouti',
    status: 'assigned',
  },
  {
    alpha2: 'DK',
    alpha3: 'DNK',
    countryCallingCodes: ['+45'],
    currencies: ['DKK'],
    ioc: 'DEN',
    languages: ['dan'],
    name: 'Denmark',
    status: 'assigned',
  },
  {
    alpha2: 'DM',
    alpha3: 'DMA',
    countryCallingCodes: ['+1 767'],
    currencies: ['XCD'],
    ioc: 'DMA',
    languages: ['eng'],
    name: 'Dominica',
    status: 'assigned',
  },
  {
    alpha2: 'DO',
    alpha3: 'DOM',
    countryCallingCodes: ['+1 809', '+1 829', '+1 849'],
    currencies: ['DOP'],
    ioc: 'DOM',
    languages: ['spa'],
    name: 'Dominican Republic',
    status: 'assigned',
  },
  {
    alpha2: 'DZ',
    alpha3: 'DZA',
    countryCallingCodes: ['+213'],
    currencies: ['DZD'],
    ioc: 'ALG',
    languages: ['ara'],
    name: 'Algeria',
    status: 'assigned',
  },
  {
    alpha2: 'EA',
    alpha3: '',
    countryCallingCodes: [],
    currencies: ['EUR'],
    ioc: '',
    languages: [],
    name: 'Ceuta, Mulilla',
    status: 'reserved',
  },
  {
    alpha2: 'EC',
    alpha3: 'ECU',
    countryCallingCodes: ['+593'],
    currencies: ['USD'],
    ioc: 'ECU',
    languages: ['spa', 'que'],
    name: 'Ecuador',
    status: 'assigned',
  },
  {
    alpha2: 'EE',
    alpha3: 'EST',
    countryCallingCodes: ['+372'],
    currencies: ['EUR'],
    ioc: 'EST',
    languages: ['est'],
    name: 'Estonia',
    status: 'assigned',
  },
  {
    alpha2: 'EG',
    alpha3: 'EGY',
    countryCallingCodes: ['+20'],
    currencies: ['EGP'],
    ioc: 'EGY',
    languages: ['ara'],
    name: 'Egypt',
    status: 'assigned',
  },
  {
    alpha2: 'EH',
    alpha3: 'ESH',
    countryCallingCodes: ['+212'],
    currencies: ['MAD'],
    ioc: '',
    languages: [],
    name: 'Western Sahara',
    status: 'assigned',
  },
  {
    alpha2: 'ER',
    alpha3: 'ERI',
    countryCallingCodes: ['+291'],
    currencies: ['ERN'],
    ioc: 'ERI',
    languages: ['eng', 'ara', 'tir'],
    name: 'Eritrea',
    status: 'assigned',
  },
  {
    alpha2: 'ES',
    alpha3: 'ESP',
    countryCallingCodes: ['+34'],
    currencies: ['EUR'],
    ioc: 'ESP',
    languages: ['spa'],
    name: 'Spain',
    status: 'assigned',
  },
  {
    alpha2: 'ET',
    alpha3: 'ETH',
    countryCallingCodes: ['+251'],
    currencies: ['ETB'],
    ioc: 'ETH',
    languages: ['amh'],
    name: 'Ethiopia',
    status: 'assigned',
  },
  {
    alpha2: 'EU',
    alpha3: '',
    countryCallingCodes: ['+388'],
    currencies: ['EUR'],
    ioc: '',
    languages: [],
    name: 'European Union',
    status: 'reserved',
  },
  {
    alpha2: 'FI',
    alpha3: 'FIN',
    countryCallingCodes: ['+358'],
    currencies: ['EUR'],
    ioc: 'FIN',
    languages: ['fin', 'swe'],
    name: 'Finland',
    status: 'assigned',
  },
  {
    alpha2: 'FJ',
    alpha3: 'FJI',
    countryCallingCodes: ['+679'],
    currencies: ['FJD'],
    ioc: 'FIJ',
    languages: ['eng', 'fij'],
    name: 'Fiji',
    status: 'assigned',
  },
  {
    alpha2: 'FK',
    alpha3: 'FLK',
    countryCallingCodes: ['+500'],
    currencies: ['FKP'],
    ioc: '',
    languages: ['eng'],
    name: 'Falkland Islands',
    status: 'assigned',
  },
  {
    alpha2: 'FM',
    alpha3: 'FSM',
    countryCallingCodes: ['+691'],
    currencies: ['USD'],
    ioc: '',
    languages: ['eng'],
    name: 'Micronesia, Federated States Of',
    status: 'assigned',
  },
  {
    alpha2: 'FO',
    alpha3: 'FRO',
    countryCallingCodes: ['+298'],
    currencies: ['DKK'],
    ioc: 'FAI',
    languages: ['fao', 'dan'],
    name: 'Faroe Islands',
    status: 'assigned',
  },
  {
    alpha2: 'FR',
    alpha3: 'FRA',
    countryCallingCodes: ['+33'],
    currencies: ['EUR'],
    ioc: 'FRA',
    languages: ['fre'],
    name: 'France',
    status: 'assigned',
  },
  {
    alpha2: 'FX',
    alpha3: '',
    countryCallingCodes: ['+241'],
    currencies: ['EUR'],
    ioc: '',
    languages: ['fre'],
    name: 'France, Metropolitan',
    status: 'reserved',
  },
  {
    alpha2: 'GA',
    alpha3: 'GAB',
    countryCallingCodes: ['+241'],
    currencies: ['XAF'],
    ioc: 'GAB',
    languages: ['fre'],
    name: 'Gabon',
    status: 'assigned',
  },
  {
    alpha2: 'GB',
    alpha3: 'GBR',
    countryCallingCodes: ['+44'],
    currencies: ['GBP'],
    ioc: 'GBR',
    languages: ['eng', 'cor', 'gle', 'gla', 'wel'],
    name: 'United Kingdom',
    status: 'assigned',
  },
  {
    alpha2: 'GD',
    alpha3: 'GRD',
    countryCallingCodes: ['+473'],
    currencies: ['XCD'],
    ioc: 'GRN',
    languages: ['eng'],
    name: 'Grenada',
    status: 'assigned',
  },
  {
    alpha2: 'GE',
    alpha3: 'GEO',
    countryCallingCodes: ['+995'],
    currencies: ['GEL'],
    ioc: 'GEO',
    languages: ['geo'],
    name: 'Georgia',
    status: 'assigned',
  },
  {
    alpha2: 'GF',
    alpha3: 'GUF',
    countryCallingCodes: ['+594'],
    currencies: ['EUR'],
    ioc: '',
    languages: ['fre'],
    name: 'French Guiana',
    status: 'assigned',
  },
  {
    alpha2: 'GG',
    alpha3: 'GGY',
    countryCallingCodes: ['+44'],
    currencies: ['GBP'],
    ioc: 'GCI',
    languages: ['fre'],
    name: 'Guernsey',
    status: 'assigned',
  },
  {
    alpha2: 'GH',
    alpha3: 'GHA',
    countryCallingCodes: ['+233'],
    currencies: ['GHS'],
    ioc: 'GHA',
    languages: ['eng'],
    name: 'Ghana',
    status: 'assigned',
  },
  {
    alpha2: 'GI',
    alpha3: 'GIB',
    countryCallingCodes: ['+350'],
    currencies: ['GIP'],
    ioc: '',
    languages: ['eng'],
    name: 'Gibraltar',
    status: 'assigned',
  },
  {
    alpha2: 'GL',
    alpha3: 'GRL',
    countryCallingCodes: ['+299'],
    currencies: ['DKK'],
    ioc: '',
    languages: ['kal'],
    name: 'Greenland',
    status: 'assigned',
  },
  {
    alpha2: 'GM',
    alpha3: 'GMB',
    countryCallingCodes: ['+220'],
    currencies: ['GMD'],
    ioc: 'GAM',
    languages: ['eng'],
    name: 'Gambia',
    status: 'assigned',
  },
  {
    alpha2: 'GN',
    alpha3: 'GIN',
    countryCallingCodes: ['+224'],
    currencies: ['GNF'],
    ioc: 'GUI',
    languages: ['fre'],
    name: 'Guinea',
    status: 'assigned',
  },
  {
    alpha2: 'GP',
    alpha3: 'GLP',
    countryCallingCodes: ['+590'],
    currencies: ['EUR'],
    ioc: '',
    languages: ['fre'],
    name: 'Guadeloupe',
    status: 'assigned',
  },
  {
    alpha2: 'GQ',
    alpha3: 'GNQ',
    countryCallingCodes: ['+240'],
    currencies: ['XAF'],
    ioc: 'GEQ',
    languages: ['spa', 'fre', 'por'],
    name: 'Equatorial Guinea',
    status: 'assigned',
  },
  {
    alpha2: 'GR',
    alpha3: 'GRC',
    countryCallingCodes: ['+30'],
    currencies: ['EUR'],
    ioc: 'GRE',
    languages: ['gre'],
    name: 'Greece',
    status: 'assigned',
  },
  {
    alpha2: 'GS',
    alpha3: 'SGS',
    countryCallingCodes: [],
    currencies: ['GBP'],
    ioc: '',
    languages: ['eng'],
    name: 'South Georgia And The South Sandwich Islands',
    status: 'assigned',
  },
  {
    alpha2: 'GT',
    alpha3: 'GTM',
    countryCallingCodes: ['+502'],
    currencies: ['GTQ'],
    ioc: 'GUA',
    languages: ['spa'],
    name: 'Guatemala',
    status: 'assigned',
  },
  {
    alpha2: 'GU',
    alpha3: 'GUM',
    countryCallingCodes: ['+1 671'],
    currencies: ['USD'],
    ioc: 'GUM',
    languages: ['eng'],
    name: 'Guam',
    status: 'assigned',
  },
  {
    alpha2: 'GW',
    alpha3: 'GNB',
    countryCallingCodes: ['+245'],
    currencies: ['XOF'],
    ioc: 'GBS',
    languages: ['por'],
    name: 'Guinea-bissau',
    status: 'assigned',
  },
  {
    alpha2: 'GY',
    alpha3: 'GUY',
    countryCallingCodes: ['+592'],
    currencies: ['GYD'],
    ioc: 'GUY',
    languages: ['eng'],
    name: 'Guyana',
    status: 'assigned',
  },
  {
    alpha2: 'HK',
    alpha3: 'HKG',
    countryCallingCodes: ['+852'],
    currencies: ['HKD'],
    ioc: 'HKG',
    languages: ['chi', 'eng'],
    name: 'Hong Kong',
    status: 'assigned',
  },
  {
    alpha2: 'HM',
    alpha3: 'HMD',
    countryCallingCodes: [],
    currencies: ['AUD'],
    ioc: '',
    languages: [],
    name: 'Heard Island And McDonald Islands',
    status: 'assigned',
  },
  {
    alpha2: 'HN',
    alpha3: 'HND',
    countryCallingCodes: ['+504'],
    currencies: ['HNL'],
    ioc: 'HON',
    languages: ['spa'],
    name: 'Honduras',
    status: 'assigned',
  },
  {
    alpha2: 'HR',
    alpha3: 'HRV',
    countryCallingCodes: ['+385'],
    currencies: ['HRK'],
    ioc: 'CRO',
    languages: ['hrv'],
    name: 'Croatia',
    status: 'assigned',
  },
  {
    alpha2: 'HT',
    alpha3: 'HTI',
    countryCallingCodes: ['+509'],
    currencies: ['HTG', 'USD'],
    ioc: 'HAI',
    languages: ['fre', 'hat'],
    name: 'Haiti',
    status: 'assigned',
  },
  {
    alpha2: 'HU',
    alpha3: 'HUN',
    countryCallingCodes: ['+36'],
    currencies: ['HUF'],
    ioc: 'HUN',
    languages: ['hun'],
    name: 'Hungary',
    status: 'assigned',
  },
  {
    alpha2: 'IC',
    alpha3: '',
    countryCallingCodes: [],
    currencies: ['EUR'],
    ioc: '',
    languages: [],
    name: 'Canary Islands',
    status: 'reserved',
  },
  {
    alpha2: 'ID',
    alpha3: 'IDN',
    countryCallingCodes: ['+62'],
    currencies: ['IDR'],
    ioc: 'INA',
    languages: ['ind'],
    name: 'Indonesia',
    status: 'assigned',
  },
  {
    alpha2: 'IE',
    alpha3: 'IRL',
    countryCallingCodes: ['+353'],
    currencies: ['EUR'],
    ioc: 'IRL',
    languages: ['eng', 'gle'],
    name: 'Ireland',
    status: 'assigned',
  },
  {
    alpha2: 'IL',
    alpha3: 'ISR',
    countryCallingCodes: ['+972'],
    currencies: ['ILS'],
    ioc: 'ISR',
    languages: ['heb', 'ara', 'eng'],
    name: 'Israel',
    status: 'assigned',
  },
  {
    alpha2: 'IM',
    alpha3: 'IMN',
    countryCallingCodes: ['+44'],
    currencies: ['GBP'],
    ioc: '',
    languages: ['eng', 'glv'],
    name: 'Isle Of Man',
    status: 'assigned',
  },
  {
    alpha2: 'IN',
    alpha3: 'IND',
    countryCallingCodes: ['+91'],
    currencies: ['INR'],
    ioc: 'IND',
    languages: ['eng', 'hin'],
    name: 'India',
    status: 'assigned',
  },
  {
    alpha2: 'IO',
    alpha3: 'IOT',
    countryCallingCodes: ['+246'],
    currencies: ['USD'],
    ioc: '',
    languages: ['eng'],
    name: 'British Indian Ocean Territory',
    status: 'assigned',
  },
  {
    alpha2: 'IQ',
    alpha3: 'IRQ',
    countryCallingCodes: ['+964'],
    currencies: ['IQD'],
    ioc: 'IRQ',
    languages: ['ara', 'kur'],
    name: 'Iraq',
    status: 'assigned',
  },
  {
    alpha2: 'IR',
    alpha3: 'IRN',
    countryCallingCodes: ['+98'],
    currencies: ['IRR'],
    ioc: 'IRI',
    languages: ['per'],
    name: 'Iran, Islamic Republic Of',
    status: 'assigned',
  },
  {
    alpha2: 'IS',
    alpha3: 'ISL',
    countryCallingCodes: ['+354'],
    currencies: ['ISK'],
    ioc: 'ISL',
    languages: ['ice'],
    name: 'Iceland',
    status: 'assigned',
  },
  {
    alpha2: 'IT',
    alpha3: 'ITA',
    countryCallingCodes: ['+39'],
    currencies: ['EUR'],
    ioc: 'ITA',
    languages: ['ita'],
    name: 'Italy',
    status: 'assigned',
  },
  {
    alpha2: 'JE',
    alpha3: 'JEY',
    countryCallingCodes: ['+44'],
    currencies: ['GBP'],
    ioc: 'JCI',
    languages: ['eng', 'fre'],
    name: 'Jersey',
    status: 'assigned',
  },
  {
    alpha2: 'JM',
    alpha3: 'JAM',
    countryCallingCodes: ['+1 876'],
    currencies: ['JMD'],
    ioc: 'JAM',
    languages: ['eng'],
    name: 'Jamaica',
    status: 'assigned',
  },
  {
    alpha2: 'JO',
    alpha3: 'JOR',
    countryCallingCodes: ['+962'],
    currencies: ['JOD'],
    ioc: 'JOR',
    languages: ['ara'],
    name: 'Jordan',
    status: 'assigned',
  },
  {
    alpha2: 'JP',
    alpha3: 'JPN',
    countryCallingCodes: ['+81'],
    currencies: ['JPY'],
    ioc: 'JPN',
    languages: ['jpn'],
    name: 'Japan',
    status: 'assigned',
  },
  {
    alpha2: 'KE',
    alpha3: 'KEN',
    countryCallingCodes: ['+254'],
    currencies: ['KES'],
    ioc: 'KEN',
    languages: ['eng', 'swa'],
    name: 'Kenya',
    status: 'assigned',
  },
  {
    alpha2: 'KG',
    alpha3: 'KGZ',
    countryCallingCodes: ['+996'],
    currencies: ['KGS'],
    ioc: 'KGZ',
    languages: ['rus'],
    name: 'Kyrgyzstan',
    status: 'assigned',
  },
  {
    alpha2: 'KH',
    alpha3: 'KHM',
    countryCallingCodes: ['+855'],
    currencies: ['KHR'],
    ioc: 'CAM',
    languages: ['khm'],
    name: 'Cambodia',
    status: 'assigned',
  },
  {
    alpha2: 'KI',
    alpha3: 'KIR',
    countryCallingCodes: ['+686'],
    currencies: ['AUD'],
    ioc: 'KIR',
    languages: ['eng'],
    name: 'Kiribati',
    status: 'assigned',
  },
  {
    alpha2: 'KM',
    alpha3: 'COM',
    countryCallingCodes: ['+269'],
    currencies: ['KMF'],
    ioc: 'COM',
    languages: ['ara', 'fre'],
    name: 'Comoros',
    status: 'assigned',
  },
  {
    alpha2: 'KN',
    alpha3: 'KNA',
    countryCallingCodes: ['+1 869'],
    currencies: ['XCD'],
    ioc: 'SKN',
    languages: ['eng'],
    name: 'Saint Kitts And Nevis',
    status: 'assigned',
  },
  {
    alpha2: 'KP',
    alpha3: 'PRK',
    countryCallingCodes: ['+850'],
    currencies: ['KPW'],
    ioc: 'PRK',
    languages: ['kor'],
    name: "Korea, Democratic People's Republic Of",
    status: 'assigned',
  },
  {
    alpha2: 'KR',
    alpha3: 'KOR',
    countryCallingCodes: ['+82'],
    currencies: ['KRW'],
    ioc: 'KOR',
    languages: ['kor'],
    name: 'Korea, Republic Of',
    status: 'assigned',
  },
  {
    alpha2: 'KW',
    alpha3: 'KWT',
    countryCallingCodes: ['+965'],
    currencies: ['KWD'],
    ioc: 'KUW',
    languages: ['ara'],
    name: 'Kuwait',
    status: 'assigned',
  },
  {
    alpha2: 'KY',
    alpha3: 'CYM',
    countryCallingCodes: ['+1 345'],
    currencies: ['KYD'],
    ioc: 'CAY',
    languages: ['eng'],
    name: 'Cayman Islands',
    status: 'assigned',
  },
  {
    alpha2: 'KZ',
    alpha3: 'KAZ',
    countryCallingCodes: ['+7', '+7 6', '+7 7'],
    currencies: ['KZT'],
    ioc: 'KAZ',
    languages: ['kaz', 'rus'],
    name: 'Kazakhstan',
    status: 'assigned',
  },
  {
    alpha2: 'LA',
    alpha3: 'LAO',
    countryCallingCodes: ['+856'],
    currencies: ['LAK'],
    ioc: 'LAO',
    languages: ['lao'],
    name: "Lao People's Democratic Republic",
    status: 'assigned',
  },
  {
    alpha2: 'LB',
    alpha3: 'LBN',
    countryCallingCodes: ['+961'],
    currencies: ['LBP'],
    ioc: 'LIB',
    languages: ['ara', 'arm'],
    name: 'Lebanon',
    status: 'assigned',
  },
  {
    alpha2: 'LC',
    alpha3: 'LCA',
    countryCallingCodes: ['+1 758'],
    currencies: ['XCD'],
    ioc: 'LCA',
    languages: ['eng'],
    name: 'Saint Lucia',
    status: 'assigned',
  },
  {
    alpha2: 'LI',
    alpha3: 'LIE',
    countryCallingCodes: ['+423'],
    currencies: ['CHF'],
    ioc: 'LIE',
    languages: ['ger'],
    name: 'Liechtenstein',
    status: 'assigned',
  },
  {
    alpha2: 'LK',
    alpha3: 'LKA',
    countryCallingCodes: ['+94'],
    currencies: ['LKR'],
    ioc: 'SRI',
    languages: ['sin', 'tam'],
    name: 'Sri Lanka',
    status: 'assigned',
  },
  {
    alpha2: 'LR',
    alpha3: 'LBR',
    countryCallingCodes: ['+231'],
    currencies: ['LRD'],
    ioc: 'LBR',
    languages: ['eng'],
    name: 'Liberia',
    status: 'assigned',
  },
  {
    alpha2: 'LS',
    alpha3: 'LSO',
    countryCallingCodes: ['+266'],
    currencies: ['LSL', 'ZAR'],
    ioc: 'LES',
    languages: ['eng', 'sot'],
    name: 'Lesotho',
    status: 'assigned',
  },
  {
    alpha2: 'LT',
    alpha3: 'LTU',
    countryCallingCodes: ['+370'],
    currencies: ['EUR'],
    ioc: 'LTU',
    languages: ['lit'],
    name: 'Lithuania',
    status: 'assigned',
  },
  {
    alpha2: 'LU',
    alpha3: 'LUX',
    countryCallingCodes: ['+352'],
    currencies: ['EUR'],
    ioc: 'LUX',
    languages: ['fre', 'ger', 'ltz'],
    name: 'Luxembourg',
    status: 'assigned',
  },
  {
    alpha2: 'LV',
    alpha3: 'LVA',
    countryCallingCodes: ['+371'],
    currencies: ['EUR'],
    ioc: 'LAT',
    languages: ['lav'],
    name: 'Latvia',
    status: 'assigned',
  },
  {
    alpha2: 'LY',
    alpha3: 'LBY',
    countryCallingCodes: ['+218'],
    currencies: ['LYD'],
    ioc: 'LBA',
    languages: ['ara'],
    name: 'Libya',
    status: 'assigned',
  },
  {
    alpha2: 'MA',
    alpha3: 'MAR',
    countryCallingCodes: ['+212'],
    currencies: ['MAD'],
    ioc: 'MAR',
    languages: ['ara'],
    name: 'Morocco',
    status: 'assigned',
  },
  {
    alpha2: 'MC',
    alpha3: 'MCO',
    countryCallingCodes: ['+377'],
    currencies: ['EUR'],
    ioc: 'MON',
    languages: ['fre'],
    name: 'Monaco',
    status: 'assigned',
  },
  {
    alpha2: 'MD',
    alpha3: 'MDA',
    countryCallingCodes: ['+373'],
    currencies: ['MDL'],
    ioc: 'MDA',
    languages: ['rum'],
    name: 'Moldova',
    status: 'assigned',
  },
  {
    alpha2: 'ME',
    alpha3: 'MNE',
    countryCallingCodes: ['+382'],
    currencies: ['EUR'],
    ioc: 'MNE',
    languages: ['mot'],
    name: 'Montenegro',
    status: 'assigned',
  },
  {
    alpha2: 'MF',
    alpha3: 'MAF',
    countryCallingCodes: ['+590'],
    currencies: ['EUR'],
    ioc: '',
    languages: ['fre'],
    name: 'Saint Martin',
    status: 'assigned',
  },
  {
    alpha2: 'MG',
    alpha3: 'MDG',
    countryCallingCodes: ['+261'],
    currencies: ['MGA'],
    ioc: 'MAD',
    languages: ['fre', 'mlg'],
    name: 'Madagascar',
    status: 'assigned',
  },
  {
    alpha2: 'MH',
    alpha3: 'MHL',
    countryCallingCodes: ['+692'],
    currencies: ['USD'],
    ioc: 'MHL',
    languages: ['eng', 'mah'],
    name: 'Marshall Islands',
    status: 'assigned',
  },
  {
    alpha2: 'MK',
    alpha3: 'MKD',
    countryCallingCodes: ['+389'],
    currencies: ['MKD'],
    ioc: 'MKD',
    languages: ['mac'],
    name: 'Macedonia, The Former Yugoslav Republic Of',
    status: 'assigned',
  },
  {
    alpha2: 'ML',
    alpha3: 'MLI',
    countryCallingCodes: ['+223'],
    currencies: ['XOF'],
    ioc: 'MLI',
    languages: ['fre'],
    name: 'Mali',
    status: 'assigned',
  },
  {
    alpha2: 'MM',
    alpha3: 'MMR',
    countryCallingCodes: ['+95'],
    currencies: ['MMK'],
    ioc: 'MYA',
    languages: ['bur'],
    name: 'Myanmar',
    status: 'assigned',
  },
  {
    alpha2: 'MN',
    alpha3: 'MNG',
    countryCallingCodes: ['+976'],
    currencies: ['MNT'],
    ioc: 'MGL',
    languages: ['mon'],
    name: 'Mongolia',
    status: 'assigned',
  },
  {
    alpha2: 'MO',
    alpha3: 'MAC',
    countryCallingCodes: ['+853'],
    currencies: ['MOP'],
    ioc: 'MAC',
    languages: ['chi', 'por'],
    name: 'Macao',
    status: 'assigned',
  },
  {
    alpha2: 'MP',
    alpha3: 'MNP',
    countryCallingCodes: ['+1 670'],
    currencies: ['USD'],
    ioc: '',
    languages: ['eng'],
    name: 'Northern Mariana Islands',
    status: 'assigned',
  },
  {
    alpha2: 'MQ',
    alpha3: 'MTQ',
    countryCallingCodes: ['+596'],
    currencies: ['EUR'],
    ioc: '',
    languages: [],
    name: 'Martinique',
    status: 'assigned',
  },
  {
    alpha2: 'MR',
    alpha3: 'MRT',
    countryCallingCodes: ['+222'],
    currencies: ['MRO'],
    ioc: 'MTN',
    languages: ['ara', 'fre'],
    name: 'Mauritania',
    status: 'assigned',
  },
  {
    alpha2: 'MS',
    alpha3: 'MSR',
    countryCallingCodes: ['+1 664'],
    currencies: ['XCD'],
    ioc: '',
    languages: [],
    name: 'Montserrat',
    status: 'assigned',
  },
  {
    alpha2: 'MT',
    alpha3: 'MLT',
    countryCallingCodes: ['+356'],
    currencies: ['EUR'],
    ioc: 'MLT',
    languages: ['mlt', 'eng'],
    name: 'Malta',
    status: 'assigned',
  },
  {
    alpha2: 'MU',
    alpha3: 'MUS',
    countryCallingCodes: ['+230'],
    currencies: ['MUR'],
    ioc: 'MRI',
    languages: ['eng', 'fre'],
    name: 'Mauritius',
    status: 'assigned',
  },
  {
    alpha2: 'MV',
    alpha3: 'MDV',
    countryCallingCodes: ['+960'],
    currencies: ['MVR'],
    ioc: 'MDV',
    languages: ['div'],
    name: 'Maldives',
    status: 'assigned',
  },
  {
    alpha2: 'MW',
    alpha3: 'MWI',
    countryCallingCodes: ['+265'],
    currencies: ['MWK'],
    ioc: 'MAW',
    languages: ['eng', 'nya'],
    name: 'Malawi',
    status: 'assigned',
  },
  {
    alpha2: 'MX',
    alpha3: 'MEX',
    countryCallingCodes: ['+52'],
    currencies: ['MXN', 'MXV'],
    ioc: 'MEX',
    languages: ['spa'],
    name: 'Mexico',
    status: 'assigned',
  },
  {
    alpha2: 'MY',
    alpha3: 'MYS',
    countryCallingCodes: ['+60'],
    currencies: ['MYR'],
    ioc: 'MAS',
    languages: ['msa', 'eng'],
    name: 'Malaysia',
    status: 'assigned',
  },
  {
    alpha2: 'MZ',
    alpha3: 'MOZ',
    countryCallingCodes: ['+258'],
    currencies: ['MZN'],
    ioc: 'MOZ',
    languages: ['por'],
    name: 'Mozambique',
    status: 'assigned',
  },
  {
    alpha2: 'NA',
    alpha3: 'NAM',
    countryCallingCodes: ['+264'],
    currencies: ['NAD', 'ZAR'],
    ioc: 'NAM',
    languages: ['eng'],
    name: 'Namibia',
    status: 'assigned',
  },
  {
    alpha2: 'NC',
    alpha3: 'NCL',
    countryCallingCodes: ['+687'],
    currencies: ['XPF'],
    ioc: '',
    languages: ['fre'],
    name: 'New Caledonia',
    status: 'assigned',
  },
  {
    alpha2: 'NE',
    alpha3: 'NER',
    countryCallingCodes: ['+227'],
    currencies: ['XOF'],
    ioc: 'NIG',
    languages: ['fre'],
    name: 'Niger',
    status: 'assigned',
  },
  {
    alpha2: 'NF',
    alpha3: 'NFK',
    countryCallingCodes: ['+672'],
    currencies: ['AUD'],
    ioc: '',
    languages: ['eng'],
    name: 'Norfolk Island',
    status: 'assigned',
  },
  {
    alpha2: 'NG',
    alpha3: 'NGA',
    countryCallingCodes: ['+234'],
    currencies: ['NGN'],
    ioc: 'NGR',
    languages: ['eng'],
    name: 'Nigeria',
    status: 'assigned',
  },
  {
    alpha2: 'NI',
    alpha3: 'NIC',
    countryCallingCodes: ['+505'],
    currencies: ['NIO'],
    ioc: 'NCA',
    languages: ['spa'],
    name: 'Nicaragua',
    status: 'assigned',
  },
  {
    alpha2: 'NL',
    alpha3: 'NLD',
    countryCallingCodes: ['+31'],
    currencies: ['EUR'],
    ioc: 'NED',
    languages: ['dut'],
    name: 'Netherlands',
    status: 'assigned',
  },
  {
    alpha2: 'NO',
    alpha3: 'NOR',
    countryCallingCodes: ['+47'],
    currencies: ['NOK'],
    ioc: 'NOR',
    languages: ['nor'],
    name: 'Norway',
    status: 'assigned',
  },
  {
    alpha2: 'NP',
    alpha3: 'NPL',
    countryCallingCodes: ['+977'],
    currencies: ['NPR'],
    ioc: 'NEP',
    languages: ['nep'],
    name: 'Nepal',
    status: 'assigned',
  },
  {
    alpha2: 'NR',
    alpha3: 'NRU',
    countryCallingCodes: ['+674'],
    currencies: ['AUD'],
    ioc: 'NRU',
    languages: ['eng', 'nau'],
    name: 'Nauru',
    status: 'assigned',
  },
  {
    alpha2: 'NU',
    alpha3: 'NIU',
    countryCallingCodes: ['+683'],
    currencies: ['NZD'],
    ioc: '',
    languages: ['eng'],
    name: 'Niue',
    status: 'assigned',
  },
  {
    alpha2: 'NZ',
    alpha3: 'NZL',
    countryCallingCodes: ['+64'],
    currencies: ['NZD'],
    ioc: 'NZL',
    languages: ['eng'],
    name: 'New Zealand',
    status: 'assigned',
  },
  {
    alpha2: 'OM',
    alpha3: 'OMN',
    countryCallingCodes: ['+968'],
    currencies: ['OMR'],
    ioc: 'OMA',
    languages: ['ara'],
    name: 'Oman',
    status: 'assigned',
  },
  {
    alpha2: 'PA',
    alpha3: 'PAN',
    countryCallingCodes: ['+507'],
    currencies: ['PAB', 'USD'],
    ioc: 'PAN',
    languages: ['spa'],
    name: 'Panama',
    status: 'assigned',
  },
  {
    alpha2: 'PE',
    alpha3: 'PER',
    countryCallingCodes: ['+51'],
    currencies: ['PEN'],
    ioc: 'PER',
    languages: ['spa', 'aym', 'que'],
    name: 'Peru',
    status: 'assigned',
  },
  {
    alpha2: 'PF',
    alpha3: 'PYF',
    countryCallingCodes: ['+689'],
    currencies: ['XPF'],
    ioc: '',
    languages: ['fre'],
    name: 'French Polynesia',
    status: 'assigned',
  },
  {
    alpha2: 'PG',
    alpha3: 'PNG',
    countryCallingCodes: ['+675'],
    currencies: ['PGK'],
    ioc: 'PNG',
    languages: ['eng'],
    name: 'Papua New Guinea',
    status: 'assigned',
  },
  {
    alpha2: 'PH',
    alpha3: 'PHL',
    countryCallingCodes: ['+63'],
    currencies: ['PHP'],
    ioc: 'PHI',
    languages: ['eng'],
    name: 'Philippines',
    status: 'assigned',
  },
  {
    alpha2: 'PK',
    alpha3: 'PAK',
    countryCallingCodes: ['+92'],
    currencies: ['PKR'],
    ioc: 'PAK',
    languages: ['urd', 'eng'],
    name: 'Pakistan',
    status: 'assigned',
  },
  {
    alpha2: 'PL',
    alpha3: 'POL',
    countryCallingCodes: ['+48'],
    currencies: ['PLN'],
    ioc: 'POL',
    languages: ['pol'],
    name: 'Poland',
    status: 'assigned',
  },
  {
    alpha2: 'PM',
    alpha3: 'SPM',
    countryCallingCodes: ['+508'],
    currencies: ['EUR'],
    ioc: '',
    languages: ['eng'],
    name: 'Saint Pierre And Miquelon',
    status: 'assigned',
  },
  {
    alpha2: 'PN',
    alpha3: 'PCN',
    countryCallingCodes: ['+872'],
    currencies: ['NZD'],
    ioc: '',
    languages: ['eng'],
    name: 'Pitcairn',
    status: 'assigned',
  },
  {
    alpha2: 'PR',
    alpha3: 'PRI',
    countryCallingCodes: ['+1 787', '+1 939'],
    currencies: ['USD'],
    ioc: 'PUR',
    languages: ['spa', 'eng'],
    name: 'Puerto Rico',
    status: 'assigned',
  },
  {
    alpha2: 'PS',
    alpha3: 'PSE',
    countryCallingCodes: ['+970'],
    currencies: ['JOD', 'EGP', 'ILS'],
    ioc: 'PLE',
    languages: ['ara'],
    name: 'Palestinian Territory, Occupied',
    status: 'assigned',
  },
  {
    alpha2: 'PT',
    alpha3: 'PRT',
    countryCallingCodes: ['+351'],
    currencies: ['EUR'],
    ioc: 'POR',
    languages: ['por'],
    name: 'Portugal',
    status: 'assigned',
  },
  {
    alpha2: 'PW',
    alpha3: 'PLW',
    countryCallingCodes: ['+680'],
    currencies: ['USD'],
    ioc: 'PLW',
    languages: ['eng'],
    name: 'Palau',
    status: 'assigned',
  },
  {
    alpha2: 'PY',
    alpha3: 'PRY',
    countryCallingCodes: ['+595'],
    currencies: ['PYG'],
    ioc: 'PAR',
    languages: ['spa'],
    name: 'Paraguay',
    status: 'assigned',
  },
  {
    alpha2: 'QA',
    alpha3: 'QAT',
    countryCallingCodes: ['+974'],
    currencies: ['QAR'],
    ioc: 'QAT',
    languages: ['ara'],
    name: 'Qatar',
    status: 'assigned',
  },
  {
    alpha2: 'RE',
    alpha3: 'REU',
    countryCallingCodes: ['+262'],
    currencies: ['EUR'],
    ioc: '',
    languages: ['fre'],
    name: 'Reunion',
    status: 'assigned',
  },
  {
    alpha2: 'RO',
    alpha3: 'ROU',
    countryCallingCodes: ['+40'],
    currencies: ['RON'],
    ioc: 'ROU',
    languages: ['rum'],
    name: 'Romania',
    status: 'assigned',
  },
  {
    alpha2: 'RS',
    alpha3: 'SRB',
    countryCallingCodes: ['+381'],
    currencies: ['RSD'],
    ioc: 'SRB',
    languages: ['srp'],
    name: 'Serbia',
    status: 'assigned',
  },
  {
    alpha2: 'RU',
    alpha3: 'RUS',
    countryCallingCodes: ['+7', '+7 3', '+7 4', '+7 8'],
    currencies: ['RUB'],
    ioc: 'RUS',
    languages: ['rus'],
    name: 'Russian Federation',
    status: 'assigned',
  },
  {
    alpha2: 'RW',
    alpha3: 'RWA',
    countryCallingCodes: ['+250'],
    currencies: ['RWF'],
    ioc: 'RWA',
    languages: ['eng', 'fre', 'kin'],
    name: 'Rwanda',
    status: 'assigned',
  },
  {
    alpha2: 'SA',
    alpha3: 'SAU',
    countryCallingCodes: ['+966'],
    currencies: ['SAR'],
    ioc: 'KSA',
    languages: ['ara'],
    name: 'Saudi Arabia',
    status: 'assigned',
  },
  {
    alpha2: 'SB',
    alpha3: 'SLB',
    countryCallingCodes: ['+677'],
    currencies: ['SBD'],
    ioc: 'SOL',
    languages: ['eng'],
    name: 'Solomon Islands',
    status: 'assigned',
  },
  {
    alpha2: 'SC',
    alpha3: 'SYC',
    countryCallingCodes: ['+248'],
    currencies: ['SCR'],
    ioc: 'SEY',
    languages: ['eng', 'fre'],
    name: 'Seychelles',
    status: 'assigned',
  },
  {
    alpha2: 'SD',
    alpha3: 'SDN',
    countryCallingCodes: ['+249'],
    currencies: ['SDG'],
    ioc: 'SUD',
    languages: ['ara', 'eng'],
    name: 'Sudan',
    status: 'assigned',
  },
  {
    alpha2: 'SE',
    alpha3: 'SWE',
    countryCallingCodes: ['+46'],
    currencies: ['SEK'],
    ioc: 'SWE',
    languages: ['swe'],
    name: 'Sweden',
    status: 'assigned',
  },
  {
    alpha2: 'SG',
    alpha3: 'SGP',
    countryCallingCodes: ['+65'],
    currencies: ['SGD'],
    ioc: 'SIN',
    languages: ['eng', 'chi', 'may', 'tam'],
    name: 'Singapore',
    status: 'assigned',
  },
  {
    alpha2: 'SH',
    alpha3: 'SHN',
    countryCallingCodes: ['+290'],
    currencies: ['SHP'],
    ioc: '',
    languages: ['eng'],
    name: 'Saint Helena, Ascension And Tristan Da Cunha',
    status: 'assigned',
  },
  {
    alpha2: 'SI',
    alpha3: 'SVN',
    countryCallingCodes: ['+386'],
    currencies: ['EUR'],
    ioc: 'SLO',
    languages: ['slv'],
    name: 'Slovenia',
    status: 'assigned',
  },
  {
    alpha2: 'SJ',
    alpha3: 'SJM',
    countryCallingCodes: ['+47'],
    currencies: ['NOK'],
    ioc: '',
    languages: [],
    name: 'Svalbard And Jan Mayen',
    status: 'assigned',
  },
  {
    alpha2: 'SK',
    alpha3: 'SVK',
    countryCallingCodes: ['+421'],
    currencies: ['EUR'],
    ioc: 'SVK',
    languages: ['slo'],
    name: 'Slovakia',
    status: 'assigned',
  },
  {
    alpha2: 'SL',
    alpha3: 'SLE',
    countryCallingCodes: ['+232'],
    currencies: ['SLL'],
    ioc: 'SLE',
    languages: ['eng'],
    name: 'Sierra Leone',
    status: 'assigned',
  },
  {
    alpha2: 'SM',
    alpha3: 'SMR',
    countryCallingCodes: ['+378'],
    currencies: ['EUR'],
    ioc: 'SMR',
    languages: ['ita'],
    name: 'San Marino',
    status: 'assigned',
  },
  {
    alpha2: 'SN',
    alpha3: 'SEN',
    countryCallingCodes: ['+221'],
    currencies: ['XOF'],
    ioc: 'SEN',
    languages: ['fre'],
    name: 'Senegal',
    status: 'assigned',
  },
  {
    alpha2: 'SO',
    alpha3: 'SOM',
    countryCallingCodes: ['+252'],
    currencies: ['SOS'],
    ioc: 'SOM',
    languages: ['som'],
    name: 'Somalia',
    status: 'assigned',
  },
  {
    alpha2: 'SR',
    alpha3: 'SUR',
    countryCallingCodes: ['+597'],
    currencies: ['SRD'],
    ioc: 'SUR',
    languages: ['dut'],
    name: 'Suriname',
    status: 'assigned',
  },
  {
    alpha2: 'SS',
    alpha3: 'SSD',
    countryCallingCodes: ['+211'],
    currencies: ['SSP'],
    ioc: '',
    languages: ['eng'],
    name: 'South Sudan',
    status: 'assigned',
  },
  {
    alpha2: 'ST',
    alpha3: 'STP',
    countryCallingCodes: ['+239'],
    currencies: ['STD'],
    ioc: 'STP',
    languages: ['por'],
    name: 'São Tomé and Príncipe',
    status: 'assigned',
  },
  {
    alpha2: 'SU',
    alpha3: '',
    countryCallingCodes: [],
    currencies: ['RUB'],
    ioc: '',
    languages: ['rus'],
    name: 'USSR',
    status: 'reserved',
  },
  {
    alpha2: 'SV',
    alpha3: 'SLV',
    countryCallingCodes: ['+503'],
    currencies: ['USD'],
    ioc: 'ESA',
    languages: ['spa'],
    name: 'El Salvador',
    status: 'assigned',
  },
  {
    alpha2: 'SX',
    alpha3: 'SXM',
    countryCallingCodes: ['+1 721'],
    currencies: ['ANG'],
    ioc: '',
    languages: ['dut'],
    name: 'Sint Maarten',
    status: 'assigned',
  },
  {
    alpha2: 'SY',
    alpha3: 'SYR',
    countryCallingCodes: ['+963'],
    currencies: ['SYP'],
    ioc: 'SYR',
    languages: ['ara'],
    name: 'Syrian Arab Republic',
    status: 'assigned',
  },
  {
    alpha2: 'SZ',
    alpha3: 'SWZ',
    countryCallingCodes: ['+268'],
    currencies: ['SZL'],
    ioc: 'SWZ',
    languages: ['eng', 'ssw'],
    name: 'Swaziland',
    status: 'assigned',
  },
  {
    alpha2: 'TA',
    alpha3: '',
    countryCallingCodes: ['+290'],
    currencies: ['GBP'],
    ioc: '',
    languages: [],
    name: 'Tristan de Cunha',
    status: 'reserved',
  },
  {
    alpha2: 'TC',
    alpha3: 'TCA',
    countryCallingCodes: ['+1 649'],
    currencies: ['USD'],
    ioc: '',
    languages: ['eng'],
    name: 'Turks And Caicos Islands',
    status: 'assigned',
  },
  {
    alpha2: 'TD',
    alpha3: 'TCD',
    countryCallingCodes: ['+235'],
    currencies: ['XAF'],
    ioc: 'CHA',
    languages: ['ara', 'fre'],
    name: 'Chad',
    status: 'assigned',
  },
  {
    alpha2: 'TF',
    alpha3: 'ATF',
    countryCallingCodes: [],
    currencies: ['EUR'],
    ioc: '',
    languages: ['fre'],
    name: 'French Southern Territories',
    status: 'assigned',
  },
  {
    alpha2: 'TG',
    alpha3: 'TGO',
    countryCallingCodes: ['+228'],
    currencies: ['XOF'],
    ioc: 'TOG',
    languages: ['fre'],
    name: 'Togo',
    status: 'assigned',
  },
  {
    alpha2: 'TH',
    alpha3: 'THA',
    countryCallingCodes: ['+66'],
    currencies: ['THB'],
    ioc: 'THA',
    languages: ['tha'],
    name: 'Thailand',
    status: 'assigned',
  },
  {
    alpha2: 'TJ',
    alpha3: 'TJK',
    countryCallingCodes: ['+992'],
    currencies: ['TJS'],
    ioc: 'TJK',
    languages: ['tgk', 'rus'],
    name: 'Tajikistan',
    status: 'assigned',
  },
  {
    alpha2: 'TK',
    alpha3: 'TKL',
    countryCallingCodes: ['+690'],
    currencies: ['NZD'],
    ioc: '',
    languages: ['eng'],
    name: 'Tokelau',
    status: 'assigned',
  },
  {
    alpha2: 'TL',
    alpha3: 'TLS',
    countryCallingCodes: ['+670'],
    currencies: ['USD'],
    ioc: 'TLS',
    languages: ['por'],
    name: 'East Timor',
    status: 'assigned',
  },
  {
    alpha2: 'TM',
    alpha3: 'TKM',
    countryCallingCodes: ['+993'],
    currencies: ['TMT'],
    ioc: 'TKM',
    languages: ['tuk', 'rus'],
    name: 'Turkmenistan',
    status: 'assigned',
  },
  {
    alpha2: 'TN',
    alpha3: 'TUN',
    countryCallingCodes: ['+216'],
    currencies: ['TND'],
    ioc: 'TUN',
    languages: ['ara'],
    name: 'Tunisia',
    status: 'assigned',
  },
  {
    alpha2: 'TO',
    alpha3: 'TON',
    countryCallingCodes: ['+676'],
    currencies: ['TOP'],
    ioc: 'TGA',
    languages: ['eng'],
    name: 'Tonga',
    status: 'assigned',
  },
  {
    alpha2: 'TR',
    alpha3: 'TUR',
    countryCallingCodes: ['+90'],
    currencies: ['TRY'],
    ioc: 'TUR',
    languages: ['tur'],
    name: 'Turkey',
    status: 'assigned',
  },
  {
    alpha2: 'TT',
    alpha3: 'TTO',
    countryCallingCodes: ['+1 868'],
    currencies: ['TTD'],
    ioc: 'TRI',
    languages: ['eng'],
    name: 'Trinidad And Tobago',
    status: 'assigned',
  },
  {
    alpha2: 'TV',
    alpha3: 'TUV',
    countryCallingCodes: ['+688'],
    currencies: ['AUD'],
    ioc: 'TUV',
    languages: ['eng'],
    name: 'Tuvalu',
    status: 'assigned',
  },
  {
    alpha2: 'TW',
    alpha3: 'TWN',
    countryCallingCodes: ['+886'],
    currencies: ['TWD'],
    ioc: 'TPE',
    languages: ['chi'],
    name: 'Taiwan, Province Of China',
    status: 'assigned',
  },
  {
    alpha2: 'TZ',
    alpha3: 'TZA',
    countryCallingCodes: ['+255'],
    currencies: ['TZS'],
    ioc: 'TAN',
    languages: ['swa', 'eng'],
    name: 'Tanzania, United Republic Of',
    status: 'assigned',
  },
  {
    alpha2: 'UA',
    alpha3: 'UKR',
    countryCallingCodes: ['+380'],
    currencies: ['UAH'],
    ioc: 'UKR',
    languages: ['ukr', 'rus'],
    name: 'Ukraine',
    status: 'assigned',
  },
  {
    alpha2: 'UG',
    alpha3: 'UGA',
    countryCallingCodes: ['+256'],
    currencies: ['UGX'],
    ioc: 'UGA',
    languages: ['eng', 'swa'],
    name: 'Uganda',
    status: 'assigned',
  },
  {
    alpha2: 'UK',
    alpha3: '',
    countryCallingCodes: [],
    currencies: ['GBP'],
    ioc: '',
    languages: ['eng', 'cor', 'gle', 'gla', 'wel'],
    name: 'United Kingdom',
    status: 'reserved',
  },
  {
    alpha2: 'UM',
    alpha3: 'UMI',
    countryCallingCodes: ['+1'],
    currencies: ['USD'],
    ioc: '',
    languages: ['eng'],
    name: 'United States Minor Outlying Islands',
    status: 'assigned',
  },
  {
    alpha2: 'US',
    alpha3: 'USA',
    countryCallingCodes: ['+1'],
    currencies: ['USD'],
    ioc: 'USA',
    languages: ['eng'],
    name: 'United States',
    status: 'assigned',
  },
  {
    alpha2: 'UY',
    alpha3: 'URY',
    countryCallingCodes: ['+598'],
    currencies: ['UYU', 'UYI'],
    ioc: 'URU',
    languages: ['spa'],
    name: 'Uruguay',
    status: 'assigned',
  },
  {
    alpha2: 'UZ',
    alpha3: 'UZB',
    countryCallingCodes: ['+998'],
    currencies: ['UZS'],
    ioc: 'UZB',
    languages: ['uzb', 'rus'],
    name: 'Uzbekistan',
    status: 'assigned',
  },
  {
    alpha2: 'VA',
    alpha3: 'VAT',
    countryCallingCodes: ['+379', '+39'],
    currencies: ['EUR'],
    ioc: '',
    languages: ['ita'],
    name: 'Vatican City State',
    status: 'assigned',
  },
  {
    alpha2: 'VC',
    alpha3: 'VCT',
    countryCallingCodes: ['+1 784'],
    currencies: ['XCD'],
    ioc: 'VIN',
    languages: ['eng'],
    name: 'Saint Vincent And The Grenadines',
    status: 'assigned',
  },
  {
    alpha2: 'VE',
    alpha3: 'VEN',
    countryCallingCodes: ['+58'],
    currencies: ['VEF'],
    ioc: 'VEN',
    languages: ['spa'],
    name: 'Venezuela, Bolivarian Republic Of',
    status: 'assigned',
  },
  {
    alpha2: 'VG',
    alpha3: 'VGB',
    countryCallingCodes: ['+1 284'],
    currencies: ['USD'],
    ioc: 'ISV',
    languages: ['eng'],
    name: 'Virgin Islands (British)',
    status: 'assigned',
  },
  {
    alpha2: 'VI',
    alpha3: 'VIR',
    countryCallingCodes: ['+1 340'],
    currencies: ['USD'],
    ioc: 'ISV',
    languages: ['eng'],
    name: 'Virgin Islands (US)',
    status: 'assigned',
  },
  {
    alpha2: 'VN',
    alpha3: 'VNM',
    countryCallingCodes: ['+84'],
    currencies: ['VND'],
    ioc: 'VIE',
    languages: ['vie'],
    name: 'Viet Nam',
    status: 'assigned',
  },
  {
    alpha2: 'VU',
    alpha3: 'VUT',
    countryCallingCodes: ['+678'],
    currencies: ['VUV'],
    ioc: 'VAN',
    languages: ['bis', 'eng', 'fre'],
    name: 'Vanuatu',
    status: 'assigned',
  },
  {
    alpha2: 'WF',
    alpha3: 'WLF',
    countryCallingCodes: ['+681'],
    currencies: ['XPF'],
    ioc: '',
    languages: ['fre'],
    name: 'Wallis And Futuna',
    status: 'assigned',
  },
  {
    alpha2: 'WS',
    alpha3: 'WSM',
    countryCallingCodes: ['+685'],
    currencies: ['WST'],
    ioc: 'SAM',
    languages: ['eng', 'smo'],
    name: 'Samoa',
    status: 'assigned',
  },
  {
    alpha2: 'YE',
    alpha3: 'YEM',
    countryCallingCodes: ['+967'],
    currencies: ['YER'],
    ioc: 'YEM',
    languages: ['ara'],
    name: 'Yemen',
    status: 'assigned',
  },
  {
    alpha2: 'YT',
    alpha3: 'MYT',
    countryCallingCodes: ['+262'],
    currencies: ['EUR'],
    ioc: '',
    languages: ['fre'],
    name: 'Mayotte',
    status: 'assigned',
  },
  {
    alpha2: 'ZA',
    alpha3: 'ZAF',
    countryCallingCodes: ['+27'],
    currencies: ['ZAR'],
    ioc: 'RSA',
    languages: ['afr', 'eng', 'nbl', 'som', 'tso', 'ven', 'xho', 'zul'],
    name: 'South Africa',
    status: 'assigned',
  },
  {
    alpha2: 'ZM',
    alpha3: 'ZMB',
    countryCallingCodes: ['+260'],
    currencies: ['ZMW'],
    ioc: 'ZAM',
    languages: ['eng'],
    name: 'Zambia',
    status: 'assigned',
  },
  {
    alpha2: 'ZW',
    alpha3: 'ZWE',
    countryCallingCodes: ['+263'],
    currencies: ['USD', 'ZAR', 'BWP', 'GBP', 'EUR'],
    ioc: 'ZIM',
    languages: ['eng', 'sna', 'nde'],
    name: 'Zimbabwe',
    status: 'assigned',
  },
];

export const languagesData = [
  {
    alpha2: 'aa',
    alpha3: 'aar',
    bibliographic: '',
    name: 'Afar',
  },
  {
    alpha2: 'ab',
    alpha3: 'abk',
    bibliographic: '',
    name: 'Abkhazian',
  },
  {
    alpha2: '',
    alpha3: 'ace',
    bibliographic: '',
    name: 'Achinese',
  },
  {
    alpha2: '',
    alpha3: 'ach',
    bibliographic: '',
    name: 'Acoli',
  },
  {
    alpha2: '',
    alpha3: 'ada',
    bibliographic: '',
    name: 'Adangme',
  },
  {
    alpha2: '',
    alpha3: 'ady',
    bibliographic: '',
    name: 'Adygei',
  },
  {
    alpha2: '',
    alpha3: 'ady',
    bibliographic: '',
    name: 'Adyghe',
  },
  {
    alpha2: '',
    alpha3: 'afa',
    bibliographic: '',
    name: 'Afro-Asiatic languages',
  },
  {
    alpha2: '',
    alpha3: 'afh',
    bibliographic: '',
    name: 'Afrihili',
  },
  {
    alpha2: 'af',
    alpha3: 'afr',
    bibliographic: '',
    name: 'Afrikaans',
  },
  {
    alpha2: '',
    alpha3: 'ain',
    bibliographic: '',
    name: 'Ainu',
  },
  {
    alpha2: 'ak',
    alpha3: 'aka',
    bibliographic: '',
    name: 'Akan',
  },
  {
    alpha2: '',
    alpha3: 'akk',
    bibliographic: '',
    name: 'Akkadian',
  },
  {
    alpha2: '',
    alpha3: 'ale',
    bibliographic: '',
    name: 'Aleut',
  },
  {
    alpha2: '',
    alpha3: 'alg',
    bibliographic: '',
    name: 'Algonquian languages',
  },
  {
    alpha2: '',
    alpha3: 'alt',
    bibliographic: '',
    name: 'Southern Altai',
  },
  {
    alpha2: 'am',
    alpha3: 'amh',
    bibliographic: '',
    name: 'Amharic',
  },
  {
    alpha2: '',
    alpha3: 'ang',
    bibliographic: '',
    name: 'English, Old (ca.450-1100)',
  },
  {
    alpha2: '',
    alpha3: 'anp',
    bibliographic: '',
    name: 'Angika',
  },
  {
    alpha2: '',
    alpha3: 'apa',
    bibliographic: '',
    name: 'Apache languages',
  },
  {
    alpha2: 'ar',
    alpha3: 'ara',
    bibliographic: '',
    name: 'Arabic',
  },
  {
    alpha2: '',
    alpha3: 'arc',
    bibliographic: '',
    name: 'Imperial Aramaic (700-300 BCE)',
  },
  {
    alpha2: '',
    alpha3: 'arc',
    bibliographic: '',
    name: 'Official Aramaic (700-300 BCE)',
  },
  {
    alpha2: 'an',
    alpha3: 'arg',
    bibliographic: '',
    name: 'Aragonese',
  },
  {
    alpha2: '',
    alpha3: 'arn',
    bibliographic: '',
    name: 'Mapuche',
  },
  {
    alpha2: '',
    alpha3: 'arn',
    bibliographic: '',
    name: 'Mapudungun',
  },
  {
    alpha2: '',
    alpha3: 'arp',
    bibliographic: '',
    name: 'Arapaho',
  },
  {
    alpha2: '',
    alpha3: 'art',
    bibliographic: '',
    name: 'Artificial languages',
  },
  {
    alpha2: '',
    alpha3: 'arw',
    bibliographic: '',
    name: 'Arawak',
  },
  {
    alpha2: 'as',
    alpha3: 'asm',
    bibliographic: '',
    name: 'Assamese',
  },
  {
    alpha2: '',
    alpha3: 'ast',
    bibliographic: '',
    name: 'Asturian',
  },
  {
    alpha2: '',
    alpha3: 'ast',
    bibliographic: '',
    name: 'Asturleonese',
  },
  {
    alpha2: '',
    alpha3: 'ast',
    bibliographic: '',
    name: 'Bable',
  },
  {
    alpha2: '',
    alpha3: 'ast',
    bibliographic: '',
    name: 'Leonese',
  },
  {
    alpha2: '',
    alpha3: 'ath',
    bibliographic: '',
    name: 'Athapascan languages',
  },
  {
    alpha2: '',
    alpha3: 'aus',
    bibliographic: '',
    name: 'Australian languages',
  },
  {
    alpha2: 'av',
    alpha3: 'ava',
    bibliographic: '',
    name: 'Avaric',
  },
  {
    alpha2: 'ae',
    alpha3: 'ave',
    bibliographic: '',
    name: 'Avestan',
  },
  {
    alpha2: '',
    alpha3: 'awa',
    bibliographic: '',
    name: 'Awadhi',
  },
  {
    alpha2: 'ay',
    alpha3: 'aym',
    bibliographic: '',
    name: 'Aymara',
  },
  {
    alpha2: 'az',
    alpha3: 'aze',
    bibliographic: '',
    name: 'Azerbaijani',
  },
  {
    alpha2: '',
    alpha3: 'bad',
    bibliographic: '',
    name: 'Banda languages',
  },
  {
    alpha2: '',
    alpha3: 'bai',
    bibliographic: '',
    name: 'Bamileke languages',
  },
  {
    alpha2: 'ba',
    alpha3: 'bak',
    bibliographic: '',
    name: 'Bashkir',
  },
  {
    alpha2: '',
    alpha3: 'bal',
    bibliographic: '',
    name: 'Baluchi',
  },
  {
    alpha2: 'bm',
    alpha3: 'bam',
    bibliographic: '',
    name: 'Bambara',
  },
  {
    alpha2: '',
    alpha3: 'ban',
    bibliographic: '',
    name: 'Balinese',
  },
  {
    alpha2: '',
    alpha3: 'bas',
    bibliographic: '',
    name: 'Basa',
  },
  {
    alpha2: '',
    alpha3: 'bat',
    bibliographic: '',
    name: 'Baltic languages',
  },
  {
    alpha2: '',
    alpha3: 'bej',
    bibliographic: '',
    name: 'Bedawiyet',
  },
  {
    alpha2: '',
    alpha3: 'bej',
    bibliographic: '',
    name: 'Beja',
  },
  {
    alpha2: 'be',
    alpha3: 'bel',
    bibliographic: '',
    name: 'Belarusian',
  },
  {
    alpha2: '',
    alpha3: 'bem',
    bibliographic: '',
    name: 'Bemba',
  },
  {
    alpha2: 'bn',
    alpha3: 'ben',
    bibliographic: '',
    name: 'Bengali',
  },
  {
    alpha2: '',
    alpha3: 'ber',
    bibliographic: '',
    name: 'Berber languages',
  },
  {
    alpha2: '',
    alpha3: 'bho',
    bibliographic: '',
    name: 'Bhojpuri',
  },
  {
    alpha2: 'bh',
    alpha3: 'bih',
    bibliographic: '',
    name: 'Bihari languages',
  },
  {
    alpha2: '',
    alpha3: 'bik',
    bibliographic: '',
    name: 'Bikol',
  },
  {
    alpha2: '',
    alpha3: 'bin',
    bibliographic: '',
    name: 'Bini',
  },
  {
    alpha2: '',
    alpha3: 'bin',
    bibliographic: '',
    name: 'Edo',
  },
  {
    alpha2: 'bi',
    alpha3: 'bis',
    bibliographic: '',
    name: 'Bislama',
  },
  {
    alpha2: '',
    alpha3: 'bla',
    bibliographic: '',
    name: 'Siksika',
  },
  {
    alpha2: '',
    alpha3: 'bnt',
    bibliographic: '',
    name: 'Bantu languages',
  },
  {
    alpha2: 'bo',
    alpha3: 'bod',
    bibliographic: 'tib',
    name: 'Tibetan',
  },
  {
    alpha2: 'bs',
    alpha3: 'bos',
    bibliographic: '',
    name: 'Bosnian',
  },
  {
    alpha2: '',
    alpha3: 'bra',
    bibliographic: '',
    name: 'Braj',
  },
  {
    alpha2: 'br',
    alpha3: 'bre',
    bibliographic: '',
    name: 'Breton',
  },
  {
    alpha2: '',
    alpha3: 'btk',
    bibliographic: '',
    name: 'Batak languages',
  },
  {
    alpha2: '',
    alpha3: 'bua',
    bibliographic: '',
    name: 'Buriat',
  },
  {
    alpha2: '',
    alpha3: 'bug',
    bibliographic: '',
    name: 'Buginese',
  },
  {
    alpha2: 'bg',
    alpha3: 'bul',
    bibliographic: '',
    name: 'Bulgarian',
  },
  {
    alpha2: '',
    alpha3: 'byn',
    bibliographic: '',
    name: 'Bilin',
  },
  {
    alpha2: '',
    alpha3: 'byn',
    bibliographic: '',
    name: 'Blin',
  },
  {
    alpha2: '',
    alpha3: 'cad',
    bibliographic: '',
    name: 'Caddo',
  },
  {
    alpha2: '',
    alpha3: 'cai',
    bibliographic: '',
    name: 'Central American Indian languages',
  },
  {
    alpha2: '',
    alpha3: 'car',
    bibliographic: '',
    name: 'Galibi Carib',
  },
  {
    alpha2: 'ca',
    alpha3: 'cat',
    bibliographic: '',
    name: 'Catalan',
  },
  {
    alpha2: 'ca',
    alpha3: 'cat',
    bibliographic: '',
    name: 'Valencian',
  },
  {
    alpha2: '',
    alpha3: 'cau',
    bibliographic: '',
    name: 'Caucasian languages',
  },
  {
    alpha2: '',
    alpha3: 'ceb',
    bibliographic: '',
    name: 'Cebuano',
  },
  {
    alpha2: '',
    alpha3: 'cel',
    bibliographic: '',
    name: 'Celtic languages',
  },
  {
    alpha2: 'cs',
    alpha3: 'ces',
    bibliographic: 'cze',
    name: 'Czech',
  },
  {
    alpha2: 'ch',
    alpha3: 'cha',
    bibliographic: '',
    name: 'Chamorro',
  },
  {
    alpha2: '',
    alpha3: 'chb',
    bibliographic: '',
    name: 'Chibcha',
  },
  {
    alpha2: 'ce',
    alpha3: 'che',
    bibliographic: '',
    name: 'Chechen',
  },
  {
    alpha2: '',
    alpha3: 'chg',
    bibliographic: '',
    name: 'Chagatai',
  },
  {
    alpha2: '',
    alpha3: 'chk',
    bibliographic: '',
    name: 'Chuukese',
  },
  {
    alpha2: '',
    alpha3: 'chm',
    bibliographic: '',
    name: 'Mari',
  },
  {
    alpha2: '',
    alpha3: 'chn',
    bibliographic: '',
    name: 'Chinook jargon',
  },
  {
    alpha2: '',
    alpha3: 'cho',
    bibliographic: '',
    name: 'Choctaw',
  },
  {
    alpha2: '',
    alpha3: 'chp',
    bibliographic: '',
    name: 'Chipewyan',
  },
  {
    alpha2: '',
    alpha3: 'chp',
    bibliographic: '',
    name: 'Dene Suline',
  },
  {
    alpha2: '',
    alpha3: 'chr',
    bibliographic: '',
    name: 'Cherokee',
  },
  {
    alpha2: 'cu',
    alpha3: 'chu',
    bibliographic: '',
    name: 'Church Slavic',
  },
  {
    alpha2: 'cu',
    alpha3: 'chu',
    bibliographic: '',
    name: 'Church Slavonic',
  },
  {
    alpha2: 'cu',
    alpha3: 'chu',
    bibliographic: '',
    name: 'Old Bulgarian',
  },
  {
    alpha2: 'cu',
    alpha3: 'chu',
    bibliographic: '',
    name: 'Old Church Slavonic',
  },
  {
    alpha2: 'cu',
    alpha3: 'chu',
    bibliographic: '',
    name: 'Old Slavonic',
  },
  {
    alpha2: 'cv',
    alpha3: 'chv',
    bibliographic: '',
    name: 'Chuvash',
  },
  {
    alpha2: '',
    alpha3: 'chy',
    bibliographic: '',
    name: 'Cheyenne',
  },
  {
    alpha2: '',
    alpha3: 'cmc',
    bibliographic: '',
    name: 'Chamic languages',
  },
  {
    alpha2: '',
    alpha3: 'cop',
    bibliographic: '',
    name: 'Coptic',
  },
  {
    alpha2: 'kw',
    alpha3: 'cor',
    bibliographic: '',
    name: 'Cornish',
  },
  {
    alpha2: 'co',
    alpha3: 'cos',
    bibliographic: '',
    name: 'Corsican',
  },
  {
    alpha2: '',
    alpha3: 'cpe',
    bibliographic: '',
    name: 'Creoles and pidgins, English based',
  },
  {
    alpha2: '',
    alpha3: 'cpf',
    bibliographic: '',
    name: 'Creoles and pidgins, French-based',
  },
  {
    alpha2: '',
    alpha3: 'cpp',
    bibliographic: '',
    name: 'Creoles and pidgins, Portuguese-based',
  },
  {
    alpha2: 'cr',
    alpha3: 'cre',
    bibliographic: '',
    name: 'Cree',
  },
  {
    alpha2: '',
    alpha3: 'crh',
    bibliographic: '',
    name: 'Crimean Tatar',
  },
  {
    alpha2: '',
    alpha3: 'crh',
    bibliographic: '',
    name: 'Crimean Turkish',
  },
  {
    alpha2: '',
    alpha3: 'crp',
    bibliographic: '',
    name: 'Creoles and pidgins',
  },
  {
    alpha2: '',
    alpha3: 'csb',
    bibliographic: '',
    name: 'Kashubian',
  },
  {
    alpha2: '',
    alpha3: 'cus',
    bibliographic: '',
    name: 'Cushitic languages',
  },
  {
    alpha2: 'cy',
    alpha3: 'cym',
    bibliographic: 'wel',
    name: 'Welsh',
  },
  {
    alpha2: '',
    alpha3: 'dak',
    bibliographic: '',
    name: 'Dakota',
  },
  {
    alpha2: 'da',
    alpha3: 'dan',
    bibliographic: '',
    name: 'Danish',
  },
  {
    alpha2: '',
    alpha3: 'dar',
    bibliographic: '',
    name: 'Dargwa',
  },
  {
    alpha2: '',
    alpha3: 'day',
    bibliographic: '',
    name: 'Land Dayak languages',
  },
  {
    alpha2: '',
    alpha3: 'del',
    bibliographic: '',
    name: 'Delaware',
  },
  {
    alpha2: '',
    alpha3: 'den',
    bibliographic: '',
    name: 'Slave (Athapascan)',
  },
  {
    alpha2: 'de',
    alpha3: 'deu',
    bibliographic: 'ger',
    name: 'German',
  },
  {
    alpha2: '',
    alpha3: 'dgr',
    bibliographic: '',
    name: 'Dogrib',
  },
  {
    alpha2: '',
    alpha3: 'din',
    bibliographic: '',
    name: 'Dinka',
  },
  {
    alpha2: 'dv',
    alpha3: 'div',
    bibliographic: '',
    name: 'Dhivehi',
  },
  {
    alpha2: 'dv',
    alpha3: 'div',
    bibliographic: '',
    name: 'Divehi',
  },
  {
    alpha2: 'dv',
    alpha3: 'div',
    bibliographic: '',
    name: 'Maldivian',
  },
  {
    alpha2: '',
    alpha3: 'doi',
    bibliographic: '',
    name: 'Dogri',
  },
  {
    alpha2: '',
    alpha3: 'dra',
    bibliographic: '',
    name: 'Dravidian languages',
  },
  {
    alpha2: '',
    alpha3: 'dsb',
    bibliographic: '',
    name: 'Lower Sorbian',
  },
  {
    alpha2: '',
    alpha3: 'dua',
    bibliographic: '',
    name: 'Duala',
  },
  {
    alpha2: '',
    alpha3: 'dum',
    bibliographic: '',
    name: 'Dutch, Middle (ca.1050-1350)',
  },
  {
    alpha2: '',
    alpha3: 'dyu',
    bibliographic: '',
    name: 'Dyula',
  },
  {
    alpha2: 'dz',
    alpha3: 'dzo',
    bibliographic: '',
    name: 'Dzongkha',
  },
  {
    alpha2: '',
    alpha3: 'efi',
    bibliographic: '',
    name: 'Efik',
  },
  {
    alpha2: '',
    alpha3: 'egy',
    bibliographic: '',
    name: 'Egyptian (Ancient)',
  },
  {
    alpha2: '',
    alpha3: 'eka',
    bibliographic: '',
    name: 'Ekajuk',
  },
  {
    alpha2: 'el',
    alpha3: 'ell',
    bibliographic: 'gre',
    name: 'Greek, Modern (1453-)',
  },
  {
    alpha2: '',
    alpha3: 'elx',
    bibliographic: '',
    name: 'Elamite',
  },
  {
    alpha2: 'en',
    alpha3: 'eng',
    bibliographic: '',
    name: 'English',
  },
  {
    alpha2: '',
    alpha3: 'enm',
    bibliographic: '',
    name: 'English, Middle (1100-1500)',
  },
  {
    alpha2: 'eo',
    alpha3: 'epo',
    bibliographic: '',
    name: 'Esperanto',
  },
  {
    alpha2: 'et',
    alpha3: 'est',
    bibliographic: '',
    name: 'Estonian',
  },
  {
    alpha2: 'eu',
    alpha3: 'eus',
    bibliographic: 'baq',
    name: 'Basque',
  },
  {
    alpha2: 'ee',
    alpha3: 'ewe',
    bibliographic: '',
    name: 'Ewe',
  },
  {
    alpha2: '',
    alpha3: 'ewo',
    bibliographic: '',
    name: 'Ewondo',
  },
  {
    alpha2: '',
    alpha3: 'fan',
    bibliographic: '',
    name: 'Fang',
  },
  {
    alpha2: 'fo',
    alpha3: 'fao',
    bibliographic: '',
    name: 'Faroese',
  },
  {
    alpha2: 'fa',
    alpha3: 'fas',
    bibliographic: 'per',
    name: 'Persian',
  },
  {
    alpha2: '',
    alpha3: 'fat',
    bibliographic: '',
    name: 'Fanti',
  },
  {
    alpha2: 'fj',
    alpha3: 'fij',
    bibliographic: '',
    name: 'Fijian',
  },
  {
    alpha2: '',
    alpha3: 'fil',
    bibliographic: '',
    name: 'Filipino',
  },
  {
    alpha2: '',
    alpha3: 'fil',
    bibliographic: '',
    name: 'Pilipino',
  },
  {
    alpha2: 'fi',
    alpha3: 'fin',
    bibliographic: '',
    name: 'Finnish',
  },
  {
    alpha2: '',
    alpha3: 'fiu',
    bibliographic: '',
    name: 'Finno-Ugrian languages',
  },
  {
    alpha2: '',
    alpha3: 'fon',
    bibliographic: '',
    name: 'Fon',
  },
  {
    alpha2: 'fr',
    alpha3: 'fra',
    bibliographic: 'fre',
    name: 'French',
  },
  {
    alpha2: '',
    alpha3: 'frm',
    bibliographic: '',
    name: 'French, Middle (ca.1400-1600)',
  },
  {
    alpha2: '',
    alpha3: 'fro',
    bibliographic: '',
    name: 'French, Old (842-ca.1400)',
  },
  {
    alpha2: '',
    alpha3: 'frr',
    bibliographic: '',
    name: 'Northern Frisian',
  },
  {
    alpha2: '',
    alpha3: 'frs',
    bibliographic: '',
    name: 'Eastern Frisian',
  },
  {
    alpha2: 'fy',
    alpha3: 'fry',
    bibliographic: '',
    name: 'Western Frisian',
  },
  {
    alpha2: 'ff',
    alpha3: 'ful',
    bibliographic: '',
    name: 'Fulah',
  },
  {
    alpha2: '',
    alpha3: 'fur',
    bibliographic: '',
    name: 'Friulian',
  },
  {
    alpha2: '',
    alpha3: 'gaa',
    bibliographic: '',
    name: 'Ga',
  },
  {
    alpha2: '',
    alpha3: 'gay',
    bibliographic: '',
    name: 'Gayo',
  },
  {
    alpha2: '',
    alpha3: 'gba',
    bibliographic: '',
    name: 'Gbaya',
  },
  {
    alpha2: '',
    alpha3: 'gem',
    bibliographic: '',
    name: 'Germanic languages',
  },
  {
    alpha2: '',
    alpha3: 'gez',
    bibliographic: '',
    name: 'Geez',
  },
  {
    alpha2: '',
    alpha3: 'gil',
    bibliographic: '',
    name: 'Gilbertese',
  },
  {
    alpha2: 'gd',
    alpha3: 'gla',
    bibliographic: '',
    name: 'Gaelic',
  },
  {
    alpha2: 'gd',
    alpha3: 'gla',
    bibliographic: '',
    name: 'Scottish Gaelic',
  },
  {
    alpha2: 'ga',
    alpha3: 'gle',
    bibliographic: '',
    name: 'Irish',
  },
  {
    alpha2: 'gl',
    alpha3: 'glg',
    bibliographic: '',
    name: 'Galician',
  },
  {
    alpha2: 'gv',
    alpha3: 'glv',
    bibliographic: '',
    name: 'Manx',
  },
  {
    alpha2: '',
    alpha3: 'gmh',
    bibliographic: '',
    name: 'German, Middle High (ca.1050-1500)',
  },
  {
    alpha2: '',
    alpha3: 'goh',
    bibliographic: '',
    name: 'German, Old High (ca.750-1050)',
  },
  {
    alpha2: '',
    alpha3: 'gon',
    bibliographic: '',
    name: 'Gondi',
  },
  {
    alpha2: '',
    alpha3: 'gor',
    bibliographic: '',
    name: 'Gorontalo',
  },
  {
    alpha2: '',
    alpha3: 'got',
    bibliographic: '',
    name: 'Gothic',
  },
  {
    alpha2: '',
    alpha3: 'grb',
    bibliographic: '',
    name: 'Grebo',
  },
  {
    alpha2: '',
    alpha3: 'grc',
    bibliographic: '',
    name: 'Greek, Ancient (to 1453)',
  },
  {
    alpha2: 'gn',
    alpha3: 'grn',
    bibliographic: '',
    name: 'Guarani',
  },
  {
    alpha2: '',
    alpha3: 'gsw',
    bibliographic: '',
    name: 'Alemannic',
  },
  {
    alpha2: '',
    alpha3: 'gsw',
    bibliographic: '',
    name: 'Alsatian',
  },
  {
    alpha2: '',
    alpha3: 'gsw',
    bibliographic: '',
    name: 'Swiss German',
  },
  {
    alpha2: 'gu',
    alpha3: 'guj',
    bibliographic: '',
    name: 'Gujarati',
  },
  {
    alpha2: '',
    alpha3: 'gwi',
    bibliographic: '',
    name: "Gwich'in",
  },
  {
    alpha2: '',
    alpha3: 'hai',
    bibliographic: '',
    name: 'Haida',
  },
  {
    alpha2: 'ht',
    alpha3: 'hat',
    bibliographic: '',
    name: 'Haitian',
  },
  {
    alpha2: 'ht',
    alpha3: 'hat',
    bibliographic: '',
    name: 'Haitian Creole',
  },
  {
    alpha2: 'ha',
    alpha3: 'hau',
    bibliographic: '',
    name: 'Hausa',
  },
  {
    alpha2: '',
    alpha3: 'haw',
    bibliographic: '',
    name: 'Hawaiian',
  },
  {
    alpha2: 'he',
    alpha3: 'heb',
    bibliographic: '',
    name: 'Hebrew',
  },
  {
    alpha2: 'hz',
    alpha3: 'her',
    bibliographic: '',
    name: 'Herero',
  },
  {
    alpha2: '',
    alpha3: 'hil',
    bibliographic: '',
    name: 'Hiligaynon',
  },
  {
    alpha2: '',
    alpha3: 'him',
    bibliographic: '',
    name: 'Himachali languages',
  },
  {
    alpha2: '',
    alpha3: 'him',
    bibliographic: '',
    name: 'Western Pahari languages',
  },
  {
    alpha2: 'hi',
    alpha3: 'hin',
    bibliographic: '',
    name: 'Hindi',
  },
  {
    alpha2: '',
    alpha3: 'hit',
    bibliographic: '',
    name: 'Hittite',
  },
  {
    alpha2: '',
    alpha3: 'hmn',
    bibliographic: '',
    name: 'Hmong',
  },
  {
    alpha2: '',
    alpha3: 'hmn',
    bibliographic: '',
    name: 'Mong',
  },
  {
    alpha2: 'ho',
    alpha3: 'hmo',
    bibliographic: '',
    name: 'Hiri Motu',
  },
  {
    alpha2: 'hr',
    alpha3: 'hrv',
    bibliographic: '',
    name: 'Croatian',
  },
  {
    alpha2: '',
    alpha3: 'hsb',
    bibliographic: '',
    name: 'Upper Sorbian',
  },
  {
    alpha2: 'hu',
    alpha3: 'hun',
    bibliographic: '',
    name: 'Hungarian',
  },
  {
    alpha2: '',
    alpha3: 'hup',
    bibliographic: '',
    name: 'Hupa',
  },
  {
    alpha2: 'hy',
    alpha3: 'hye',
    bibliographic: 'arm',
    name: 'Armenian',
  },
  {
    alpha2: '',
    alpha3: 'iba',
    bibliographic: '',
    name: 'Iban',
  },
  {
    alpha2: 'ig',
    alpha3: 'ibo',
    bibliographic: '',
    name: 'Igbo',
  },
  {
    alpha2: 'io',
    alpha3: 'ido',
    bibliographic: '',
    name: 'Ido',
  },
  {
    alpha2: 'ii',
    alpha3: 'iii',
    bibliographic: '',
    name: 'Nuosu',
  },
  {
    alpha2: 'ii',
    alpha3: 'iii',
    bibliographic: '',
    name: 'Sichuan Yi',
  },
  {
    alpha2: '',
    alpha3: 'ijo',
    bibliographic: '',
    name: 'Ijo languages',
  },
  {
    alpha2: 'iu',
    alpha3: 'iku',
    bibliographic: '',
    name: 'Inuktitut',
  },
  {
    alpha2: 'ie',
    alpha3: 'ile',
    bibliographic: '',
    name: 'Interlingue',
  },
  {
    alpha2: 'ie',
    alpha3: 'ile',
    bibliographic: '',
    name: 'Occidental',
  },
  {
    alpha2: '',
    alpha3: 'ilo',
    bibliographic: '',
    name: 'Iloko',
  },
  {
    alpha2: 'ia',
    alpha3: 'ina',
    bibliographic: '',
    name: 'Interlingua (International Auxiliary Language Association)',
  },
  {
    alpha2: '',
    alpha3: 'inc',
    bibliographic: '',
    name: 'Indic languages',
  },
  {
    alpha2: 'id',
    alpha3: 'ind',
    bibliographic: '',
    name: 'Indonesian',
  },
  {
    alpha2: '',
    alpha3: 'ine',
    bibliographic: '',
    name: 'Indo-European languages',
  },
  {
    alpha2: '',
    alpha3: 'inh',
    bibliographic: '',
    name: 'Ingush',
  },
  {
    alpha2: 'ik',
    alpha3: 'ipk',
    bibliographic: '',
    name: 'Inupiaq',
  },
  {
    alpha2: '',
    alpha3: 'ira',
    bibliographic: '',
    name: 'Iranian languages',
  },
  {
    alpha2: '',
    alpha3: 'iro',
    bibliographic: '',
    name: 'Iroquoian languages',
  },
  {
    alpha2: 'is',
    alpha3: 'isl',
    bibliographic: 'ice',
    name: 'Icelandic',
  },
  {
    alpha2: 'it',
    alpha3: 'ita',
    bibliographic: '',
    name: 'Italian',
  },
  {
    alpha2: 'jv',
    alpha3: 'jav',
    bibliographic: '',
    name: 'Javanese',
  },
  {
    alpha2: '',
    alpha3: 'jbo',
    bibliographic: '',
    name: 'Lojban',
  },
  {
    alpha2: 'ja',
    alpha3: 'jpn',
    bibliographic: '',
    name: 'Japanese',
  },
  {
    alpha2: '',
    alpha3: 'jpr',
    bibliographic: '',
    name: 'Judeo-Persian',
  },
  {
    alpha2: '',
    alpha3: 'jrb',
    bibliographic: '',
    name: 'Judeo-Arabic',
  },
  {
    alpha2: '',
    alpha3: 'kaa',
    bibliographic: '',
    name: 'Kara-Kalpak',
  },
  {
    alpha2: '',
    alpha3: 'kab',
    bibliographic: '',
    name: 'Kabyle',
  },
  {
    alpha2: '',
    alpha3: 'kac',
    bibliographic: '',
    name: 'Jingpho',
  },
  {
    alpha2: '',
    alpha3: 'kac',
    bibliographic: '',
    name: 'Kachin',
  },
  {
    alpha2: 'kl',
    alpha3: 'kal',
    bibliographic: '',
    name: 'Greenlandic',
  },
  {
    alpha2: 'kl',
    alpha3: 'kal',
    bibliographic: '',
    name: 'Kalaallisut',
  },
  {
    alpha2: '',
    alpha3: 'kam',
    bibliographic: '',
    name: 'Kamba',
  },
  {
    alpha2: 'kn',
    alpha3: 'kan',
    bibliographic: '',
    name: 'Kannada',
  },
  {
    alpha2: '',
    alpha3: 'kar',
    bibliographic: '',
    name: 'Karen languages',
  },
  {
    alpha2: 'ks',
    alpha3: 'kas',
    bibliographic: '',
    name: 'Kashmiri',
  },
  {
    alpha2: 'ka',
    alpha3: 'kat',
    bibliographic: 'geo',
    name: 'Georgian',
  },
  {
    alpha2: 'kr',
    alpha3: 'kau',
    bibliographic: '',
    name: 'Kanuri',
  },
  {
    alpha2: '',
    alpha3: 'kaw',
    bibliographic: '',
    name: 'Kawi',
  },
  {
    alpha2: 'kk',
    alpha3: 'kaz',
    bibliographic: '',
    name: 'Kazakh',
  },
  {
    alpha2: '',
    alpha3: 'kbd',
    bibliographic: '',
    name: 'Kabardian',
  },
  {
    alpha2: '',
    alpha3: 'kha',
    bibliographic: '',
    name: 'Khasi',
  },
  {
    alpha2: '',
    alpha3: 'khi',
    bibliographic: '',
    name: 'Khoisan languages',
  },
  {
    alpha2: 'km',
    alpha3: 'khm',
    bibliographic: '',
    name: 'Central Khmer',
  },
  {
    alpha2: '',
    alpha3: 'kho',
    bibliographic: '',
    name: 'Khotanese',
  },
  {
    alpha2: '',
    alpha3: 'kho',
    bibliographic: '',
    name: 'Sakan',
  },
  {
    alpha2: 'ki',
    alpha3: 'kik',
    bibliographic: '',
    name: 'Gikuyu',
  },
  {
    alpha2: 'ki',
    alpha3: 'kik',
    bibliographic: '',
    name: 'Kikuyu',
  },
  {
    alpha2: 'rw',
    alpha3: 'kin',
    bibliographic: '',
    name: 'Kinyarwanda',
  },
  {
    alpha2: 'ky',
    alpha3: 'kir',
    bibliographic: '',
    name: 'Kirghiz',
  },
  {
    alpha2: 'ky',
    alpha3: 'kir',
    bibliographic: '',
    name: 'Kyrgyz',
  },
  {
    alpha2: '',
    alpha3: 'kmb',
    bibliographic: '',
    name: 'Kimbundu',
  },
  {
    alpha2: '',
    alpha3: 'kok',
    bibliographic: '',
    name: 'Konkani',
  },
  {
    alpha2: 'kv',
    alpha3: 'kom',
    bibliographic: '',
    name: 'Komi',
  },
  {
    alpha2: 'kg',
    alpha3: 'kon',
    bibliographic: '',
    name: 'Kongo',
  },
  {
    alpha2: 'ko',
    alpha3: 'kor',
    bibliographic: '',
    name: 'Korean',
  },
  {
    alpha2: '',
    alpha3: 'kos',
    bibliographic: '',
    name: 'Kosraean',
  },
  {
    alpha2: '',
    alpha3: 'kpe',
    bibliographic: '',
    name: 'Kpelle',
  },
  {
    alpha2: '',
    alpha3: 'krc',
    bibliographic: '',
    name: 'Karachay-Balkar',
  },
  {
    alpha2: '',
    alpha3: 'krl',
    bibliographic: '',
    name: 'Karelian',
  },
  {
    alpha2: '',
    alpha3: 'kro',
    bibliographic: '',
    name: 'Kru languages',
  },
  {
    alpha2: '',
    alpha3: 'kru',
    bibliographic: '',
    name: 'Kurukh',
  },
  {
    alpha2: 'kj',
    alpha3: 'kua',
    bibliographic: '',
    name: 'Kuanyama',
  },
  {
    alpha2: 'kj',
    alpha3: 'kua',
    bibliographic: '',
    name: 'Kwanyama',
  },
  {
    alpha2: '',
    alpha3: 'kum',
    bibliographic: '',
    name: 'Kumyk',
  },
  {
    alpha2: 'ku',
    alpha3: 'kur',
    bibliographic: '',
    name: 'Kurdish',
  },
  {
    alpha2: '',
    alpha3: 'kut',
    bibliographic: '',
    name: 'Kutenai',
  },
  {
    alpha2: '',
    alpha3: 'lad',
    bibliographic: '',
    name: 'Ladino',
  },
  {
    alpha2: '',
    alpha3: 'lah',
    bibliographic: '',
    name: 'Lahnda',
  },
  {
    alpha2: '',
    alpha3: 'lam',
    bibliographic: '',
    name: 'Lamba',
  },
  {
    alpha2: 'lo',
    alpha3: 'lao',
    bibliographic: '',
    name: 'Lao',
  },
  {
    alpha2: 'la',
    alpha3: 'lat',
    bibliographic: '',
    name: 'Latin',
  },
  {
    alpha2: 'lv',
    alpha3: 'lav',
    bibliographic: '',
    name: 'Latvian',
  },
  {
    alpha2: '',
    alpha3: 'lez',
    bibliographic: '',
    name: 'Lezghian',
  },
  {
    alpha2: 'li',
    alpha3: 'lim',
    bibliographic: '',
    name: 'Limburgan',
  },
  {
    alpha2: 'li',
    alpha3: 'lim',
    bibliographic: '',
    name: 'Limburger',
  },
  {
    alpha2: 'li',
    alpha3: 'lim',
    bibliographic: '',
    name: 'Limburgish',
  },
  {
    alpha2: 'ln',
    alpha3: 'lin',
    bibliographic: '',
    name: 'Lingala',
  },
  {
    alpha2: 'lt',
    alpha3: 'lit',
    bibliographic: '',
    name: 'Lithuanian',
  },
  {
    alpha2: '',
    alpha3: 'lol',
    bibliographic: '',
    name: 'Mongo',
  },
  {
    alpha2: '',
    alpha3: 'loz',
    bibliographic: '',
    name: 'Lozi',
  },
  {
    alpha2: 'lb',
    alpha3: 'ltz',
    bibliographic: '',
    name: 'Letzeburgesch',
  },
  {
    alpha2: 'lb',
    alpha3: 'ltz',
    bibliographic: '',
    name: 'Luxembourgish',
  },
  {
    alpha2: '',
    alpha3: 'lua',
    bibliographic: '',
    name: 'Luba-Lulua',
  },
  {
    alpha2: 'lu',
    alpha3: 'lub',
    bibliographic: '',
    name: 'Luba-Katanga',
  },
  {
    alpha2: 'lg',
    alpha3: 'lug',
    bibliographic: '',
    name: 'Ganda',
  },
  {
    alpha2: '',
    alpha3: 'lui',
    bibliographic: '',
    name: 'Luiseno',
  },
  {
    alpha2: '',
    alpha3: 'lun',
    bibliographic: '',
    name: 'Lunda',
  },
  {
    alpha2: '',
    alpha3: 'luo',
    bibliographic: '',
    name: 'Luo (Kenya and Tanzania)',
  },
  {
    alpha2: '',
    alpha3: 'lus',
    bibliographic: '',
    name: 'Lushai',
  },
  {
    alpha2: '',
    alpha3: 'mad',
    bibliographic: '',
    name: 'Madurese',
  },
  {
    alpha2: '',
    alpha3: 'mag',
    bibliographic: '',
    name: 'Magahi',
  },
  {
    alpha2: 'mh',
    alpha3: 'mah',
    bibliographic: '',
    name: 'Marshallese',
  },
  {
    alpha2: '',
    alpha3: 'mai',
    bibliographic: '',
    name: 'Maithili',
  },
  {
    alpha2: '',
    alpha3: 'mak',
    bibliographic: '',
    name: 'Makasar',
  },
  {
    alpha2: 'ml',
    alpha3: 'mal',
    bibliographic: '',
    name: 'Malayalam',
  },
  {
    alpha2: '',
    alpha3: 'man',
    bibliographic: '',
    name: 'Mandingo',
  },
  {
    alpha2: '',
    alpha3: 'map',
    bibliographic: '',
    name: 'Austronesian languages',
  },
  {
    alpha2: 'mr',
    alpha3: 'mar',
    bibliographic: '',
    name: 'Marathi',
  },
  {
    alpha2: '',
    alpha3: 'mas',
    bibliographic: '',
    name: 'Masai',
  },
  {
    alpha2: '',
    alpha3: 'mdf',
    bibliographic: '',
    name: 'Moksha',
  },
  {
    alpha2: '',
    alpha3: 'mdr',
    bibliographic: '',
    name: 'Mandar',
  },
  {
    alpha2: '',
    alpha3: 'men',
    bibliographic: '',
    name: 'Mende',
  },
  {
    alpha2: '',
    alpha3: 'mga',
    bibliographic: '',
    name: 'Irish, Middle (900-1200)',
  },
  {
    alpha2: '',
    alpha3: 'mic',
    bibliographic: '',
    name: "Mi'kmaq",
  },
  {
    alpha2: '',
    alpha3: 'mic',
    bibliographic: '',
    name: 'Micmac',
  },
  {
    alpha2: '',
    alpha3: 'min',
    bibliographic: '',
    name: 'Minangkabau',
  },
  {
    alpha2: '',
    alpha3: 'mis',
    bibliographic: '',
    name: 'Uncoded languages',
  },
  {
    alpha2: 'mk',
    alpha3: 'mkd',
    bibliographic: 'mac',
    name: 'Macedonian',
  },
  {
    alpha2: '',
    alpha3: 'mkh',
    bibliographic: '',
    name: 'Mon-Khmer languages',
  },
  {
    alpha2: 'mg',
    alpha3: 'mlg',
    bibliographic: '',
    name: 'Malagasy',
  },
  {
    alpha2: 'mt',
    alpha3: 'mlt',
    bibliographic: '',
    name: 'Maltese',
  },
  {
    alpha2: '',
    alpha3: 'mnc',
    bibliographic: '',
    name: 'Manchu',
  },
  {
    alpha2: '',
    alpha3: 'mni',
    bibliographic: '',
    name: 'Manipuri',
  },
  {
    alpha2: '',
    alpha3: 'mno',
    bibliographic: '',
    name: 'Manobo languages',
  },
  {
    alpha2: '',
    alpha3: 'moh',
    bibliographic: '',
    name: 'Mohawk',
  },
  {
    alpha2: 'mn',
    alpha3: 'mon',
    bibliographic: '',
    name: 'Mongolian',
  },
  {
    alpha2: '',
    alpha3: 'mos',
    bibliographic: '',
    name: 'Mossi',
  },
  {
    alpha2: '',
    alpha3: 'mot',
    bibliographic: '',
    name: 'Montenegrin',
  },
  {
    alpha2: 'mi',
    alpha3: 'mri',
    bibliographic: 'mao',
    name: 'Maori',
  },
  {
    alpha2: 'ms',
    alpha3: 'msa',
    bibliographic: 'may',
    name: 'Malay',
  },
  {
    alpha2: '',
    alpha3: 'mul',
    bibliographic: '',
    name: 'Multiple languages',
  },
  {
    alpha2: '',
    alpha3: 'mun',
    bibliographic: '',
    name: 'Munda languages',
  },
  {
    alpha2: '',
    alpha3: 'mus',
    bibliographic: '',
    name: 'Creek',
  },
  {
    alpha2: '',
    alpha3: 'mwl',
    bibliographic: '',
    name: 'Mirandese',
  },
  {
    alpha2: '',
    alpha3: 'mwr',
    bibliographic: '',
    name: 'Marwari',
  },
  {
    alpha2: 'my',
    alpha3: 'mya',
    bibliographic: 'bur',
    name: 'Burmese',
  },
  {
    alpha2: '',
    alpha3: 'myn',
    bibliographic: '',
    name: 'Mayan languages',
  },
  {
    alpha2: '',
    alpha3: 'myv',
    bibliographic: '',
    name: 'Erzya',
  },
  {
    alpha2: '',
    alpha3: 'nah',
    bibliographic: '',
    name: 'Nahuatl languages',
  },
  {
    alpha2: '',
    alpha3: 'nai',
    bibliographic: '',
    name: 'North American Indian languages',
  },
  {
    alpha2: '',
    alpha3: 'nap',
    bibliographic: '',
    name: 'Neapolitan',
  },
  {
    alpha2: 'na',
    alpha3: 'nau',
    bibliographic: '',
    name: 'Nauru',
  },
  {
    alpha2: 'nv',
    alpha3: 'nav',
    bibliographic: '',
    name: 'Navaho',
  },
  {
    alpha2: 'nv',
    alpha3: 'nav',
    bibliographic: '',
    name: 'Navajo',
  },
  {
    alpha2: 'nr',
    alpha3: 'nbl',
    bibliographic: '',
    name: 'Ndebele, South',
  },
  {
    alpha2: 'nr',
    alpha3: 'nbl',
    bibliographic: '',
    name: 'South Ndebele',
  },
  {
    alpha2: 'nd',
    alpha3: 'nde',
    bibliographic: '',
    name: 'Ndebele, North',
  },
  {
    alpha2: 'nd',
    alpha3: 'nde',
    bibliographic: '',
    name: 'North Ndebele',
  },
  {
    alpha2: 'ng',
    alpha3: 'ndo',
    bibliographic: '',
    name: 'Ndonga',
  },
  {
    alpha2: '',
    alpha3: 'nds',
    bibliographic: '',
    name: 'German, Low',
  },
  {
    alpha2: '',
    alpha3: 'nds',
    bibliographic: '',
    name: 'Low German',
  },
  {
    alpha2: '',
    alpha3: 'nds',
    bibliographic: '',
    name: 'Low Saxon',
  },
  {
    alpha2: '',
    alpha3: 'nds',
    bibliographic: '',
    name: 'Saxon, Low',
  },
  {
    alpha2: 'ne',
    alpha3: 'nep',
    bibliographic: '',
    name: 'Nepali',
  },
  {
    alpha2: '',
    alpha3: 'new',
    bibliographic: '',
    name: 'Nepal Bhasa',
  },
  {
    alpha2: '',
    alpha3: 'new',
    bibliographic: '',
    name: 'Newari',
  },
  {
    alpha2: '',
    alpha3: 'nia',
    bibliographic: '',
    name: 'Nias',
  },
  {
    alpha2: '',
    alpha3: 'nic',
    bibliographic: '',
    name: 'Niger-Kordofanian languages',
  },
  {
    alpha2: '',
    alpha3: 'niu',
    bibliographic: '',
    name: 'Niuean',
  },
  {
    alpha2: 'nl',
    alpha3: 'nld',
    bibliographic: 'dut',
    name: 'Dutch',
  },
  {
    alpha2: 'nl',
    alpha3: 'nld',
    bibliographic: 'dut',
    name: 'Flemish',
  },
  {
    alpha2: 'nn',
    alpha3: 'nno',
    bibliographic: '',
    name: 'Norwegian Nynorsk',
  },
  {
    alpha2: 'nn',
    alpha3: 'nno',
    bibliographic: '',
    name: 'Nynorsk, Norwegian',
  },
  {
    alpha2: 'nb',
    alpha3: 'nob',
    bibliographic: '',
    name: 'Bokmål, Norwegian',
  },
  {
    alpha2: 'nb',
    alpha3: 'nob',
    bibliographic: '',
    name: 'Norwegian Bokmål',
  },
  {
    alpha2: '',
    alpha3: 'nog',
    bibliographic: '',
    name: 'Nogai',
  },
  {
    alpha2: '',
    alpha3: 'non',
    bibliographic: '',
    name: 'Norse, Old',
  },
  {
    alpha2: 'no',
    alpha3: 'nor',
    bibliographic: '',
    name: 'Norwegian',
  },
  {
    alpha2: '',
    alpha3: 'nqo',
    bibliographic: '',
    name: "N'Ko",
  },
  {
    alpha2: '',
    alpha3: 'nso',
    bibliographic: '',
    name: 'Northern Sotho',
  },
  {
    alpha2: '',
    alpha3: 'nso',
    bibliographic: '',
    name: 'Pedi',
  },
  {
    alpha2: '',
    alpha3: 'nso',
    bibliographic: '',
    name: 'Sepedi',
  },
  {
    alpha2: '',
    alpha3: 'nso',
    bibliographic: '',
    name: 'Sotho, Northern',
  },
  {
    alpha2: '',
    alpha3: 'nub',
    bibliographic: '',
    name: 'Nubian languages',
  },
  {
    alpha2: '',
    alpha3: 'nwc',
    bibliographic: '',
    name: 'Classical Nepal Bhasa',
  },
  {
    alpha2: '',
    alpha3: 'nwc',
    bibliographic: '',
    name: 'Classical Newari',
  },
  {
    alpha2: '',
    alpha3: 'nwc',
    bibliographic: '',
    name: 'Old Newari',
  },
  {
    alpha2: 'ny',
    alpha3: 'nya',
    bibliographic: '',
    name: 'Chewa',
  },
  {
    alpha2: 'ny',
    alpha3: 'nya',
    bibliographic: '',
    name: 'Chichewa',
  },
  {
    alpha2: 'ny',
    alpha3: 'nya',
    bibliographic: '',
    name: 'Nyanja',
  },
  {
    alpha2: '',
    alpha3: 'nym',
    bibliographic: '',
    name: 'Nyamwezi',
  },
  {
    alpha2: '',
    alpha3: 'nyn',
    bibliographic: '',
    name: 'Nyankole',
  },
  {
    alpha2: '',
    alpha3: 'nyo',
    bibliographic: '',
    name: 'Nyoro',
  },
  {
    alpha2: '',
    alpha3: 'nzi',
    bibliographic: '',
    name: 'Nzima',
  },
  {
    alpha2: 'oc',
    alpha3: 'oci',
    bibliographic: '',
    name: 'Occitan (post 1500)',
  },
  {
    alpha2: 'oj',
    alpha3: 'oji',
    bibliographic: '',
    name: 'Ojibwa',
  },
  {
    alpha2: 'or',
    alpha3: 'ori',
    bibliographic: '',
    name: 'Oriya',
  },
  {
    alpha2: 'om',
    alpha3: 'orm',
    bibliographic: '',
    name: 'Oromo',
  },
  {
    alpha2: '',
    alpha3: 'osa',
    bibliographic: '',
    name: 'Osage',
  },
  {
    alpha2: 'os',
    alpha3: 'oss',
    bibliographic: '',
    name: 'Ossetian',
  },
  {
    alpha2: 'os',
    alpha3: 'oss',
    bibliographic: '',
    name: 'Ossetic',
  },
  {
    alpha2: '',
    alpha3: 'ota',
    bibliographic: '',
    name: 'Turkish, Ottoman (1500-1928)',
  },
  {
    alpha2: '',
    alpha3: 'oto',
    bibliographic: '',
    name: 'Otomian languages',
  },
  {
    alpha2: '',
    alpha3: 'paa',
    bibliographic: '',
    name: 'Papuan languages',
  },
  {
    alpha2: '',
    alpha3: 'pag',
    bibliographic: '',
    name: 'Pangasinan',
  },
  {
    alpha2: '',
    alpha3: 'pal',
    bibliographic: '',
    name: 'Pahlavi',
  },
  {
    alpha2: '',
    alpha3: 'pam',
    bibliographic: '',
    name: 'Kapampangan',
  },
  {
    alpha2: '',
    alpha3: 'pam',
    bibliographic: '',
    name: 'Pampanga',
  },
  {
    alpha2: 'pa',
    alpha3: 'pan',
    bibliographic: '',
    name: 'Panjabi',
  },
  {
    alpha2: 'pa',
    alpha3: 'pan',
    bibliographic: '',
    name: 'Punjabi',
  },
  {
    alpha2: '',
    alpha3: 'pap',
    bibliographic: '',
    name: 'Papiamento',
  },
  {
    alpha2: '',
    alpha3: 'pau',
    bibliographic: '',
    name: 'Palauan',
  },
  {
    alpha2: '',
    alpha3: 'peo',
    bibliographic: '',
    name: 'Persian, Old (ca.600-400 B.C.)',
  },
  {
    alpha2: '',
    alpha3: 'phi',
    bibliographic: '',
    name: 'Philippine languages',
  },
  {
    alpha2: '',
    alpha3: 'phn',
    bibliographic: '',
    name: 'Phoenician',
  },
  {
    alpha2: 'pi',
    alpha3: 'pli',
    bibliographic: '',
    name: 'Pali',
  },
  {
    alpha2: 'pl',
    alpha3: 'pol',
    bibliographic: '',
    name: 'Polish',
  },
  {
    alpha2: '',
    alpha3: 'pon',
    bibliographic: '',
    name: 'Pohnpeian',
  },
  {
    alpha2: 'pt',
    alpha3: 'por',
    bibliographic: '',
    name: 'Portuguese',
  },
  {
    alpha2: '',
    alpha3: 'pra',
    bibliographic: '',
    name: 'Prakrit languages',
  },
  {
    alpha2: '',
    alpha3: 'pro',
    bibliographic: '',
    name: 'Occitan, Old (to 1500)',
  },
  {
    alpha2: '',
    alpha3: 'pro',
    bibliographic: '',
    name: 'Provençal, Old (to 1500)',
  },
  {
    alpha2: 'ps',
    alpha3: 'pus',
    bibliographic: '',
    name: 'Pashto',
  },
  {
    alpha2: 'ps',
    alpha3: 'pus',
    bibliographic: '',
    name: 'Pushto',
  },
  {
    alpha2: 'qu',
    alpha3: 'que',
    bibliographic: '',
    name: 'Quechua',
  },
  {
    alpha2: '',
    alpha3: 'raj',
    bibliographic: '',
    name: 'Rajasthani',
  },
  {
    alpha2: '',
    alpha3: 'rap',
    bibliographic: '',
    name: 'Rapanui',
  },
  {
    alpha2: '',
    alpha3: 'rar',
    bibliographic: '',
    name: 'Cook Islands Maori',
  },
  {
    alpha2: '',
    alpha3: 'rar',
    bibliographic: '',
    name: 'Rarotongan',
  },
  {
    alpha2: '',
    alpha3: 'roa',
    bibliographic: '',
    name: 'Romance languages',
  },
  {
    alpha2: 'rm',
    alpha3: 'roh',
    bibliographic: '',
    name: 'Romansh',
  },
  {
    alpha2: '',
    alpha3: 'rom',
    bibliographic: '',
    name: 'Romany',
  },
  {
    alpha2: 'ro',
    alpha3: 'ron',
    bibliographic: 'rum',
    name: 'Moldavian',
  },
  {
    alpha2: 'ro',
    alpha3: 'ron',
    bibliographic: 'rum',
    name: 'Romanian',
  },
  {
    alpha2: 'rn',
    alpha3: 'run',
    bibliographic: '',
    name: 'Rundi',
  },
  {
    alpha2: '',
    alpha3: 'rup',
    bibliographic: '',
    name: 'Aromanian',
  },
  {
    alpha2: '',
    alpha3: 'rup',
    bibliographic: '',
    name: 'Arumanian',
  },
  {
    alpha2: '',
    alpha3: 'rup',
    bibliographic: '',
    name: 'Macedo-Romanian',
  },
  {
    alpha2: 'ru',
    alpha3: 'rus',
    bibliographic: '',
    name: 'Russian',
  },
  {
    alpha2: '',
    alpha3: 'sad',
    bibliographic: '',
    name: 'Sandawe',
  },
  {
    alpha2: 'sg',
    alpha3: 'sag',
    bibliographic: '',
    name: 'Sango',
  },
  {
    alpha2: '',
    alpha3: 'sah',
    bibliographic: '',
    name: 'Yakut',
  },
  {
    alpha2: '',
    alpha3: 'sai',
    bibliographic: '',
    name: 'South American Indian languages',
  },
  {
    alpha2: '',
    alpha3: 'sal',
    bibliographic: '',
    name: 'Salishan languages',
  },
  {
    alpha2: '',
    alpha3: 'sam',
    bibliographic: '',
    name: 'Samaritan Aramaic',
  },
  {
    alpha2: 'sa',
    alpha3: 'san',
    bibliographic: '',
    name: 'Sanskrit',
  },
  {
    alpha2: '',
    alpha3: 'sas',
    bibliographic: '',
    name: 'Sasak',
  },
  {
    alpha2: '',
    alpha3: 'sat',
    bibliographic: '',
    name: 'Santali',
  },
  {
    alpha2: '',
    alpha3: 'scn',
    bibliographic: '',
    name: 'Sicilian',
  },
  {
    alpha2: '',
    alpha3: 'sco',
    bibliographic: '',
    name: 'Scots',
  },
  {
    alpha2: '',
    alpha3: 'sel',
    bibliographic: '',
    name: 'Selkup',
  },
  {
    alpha2: '',
    alpha3: 'sem',
    bibliographic: '',
    name: 'Semitic languages',
  },
  {
    alpha2: '',
    alpha3: 'sga',
    bibliographic: '',
    name: 'Irish, Old (to 900)',
  },
  {
    alpha2: '',
    alpha3: 'sgn',
    bibliographic: '',
    name: 'Sign Languages',
  },
  {
    alpha2: '',
    alpha3: 'shn',
    bibliographic: '',
    name: 'Shan',
  },
  {
    alpha2: '',
    alpha3: 'sid',
    bibliographic: '',
    name: 'Sidamo',
  },
  {
    alpha2: 'si',
    alpha3: 'sin',
    bibliographic: '',
    name: 'Sinhala',
  },
  {
    alpha2: 'si',
    alpha3: 'sin',
    bibliographic: '',
    name: 'Sinhalese',
  },
  {
    alpha2: '',
    alpha3: 'sio',
    bibliographic: '',
    name: 'Siouan languages',
  },
  {
    alpha2: '',
    alpha3: 'sit',
    bibliographic: '',
    name: 'Sino-Tibetan languages',
  },
  {
    alpha2: '',
    alpha3: 'sla',
    bibliographic: '',
    name: 'Slavic languages',
  },
  {
    alpha2: 'sk',
    alpha3: 'slk',
    bibliographic: 'slo',
    name: 'Slovak',
  },
  {
    alpha2: 'sl',
    alpha3: 'slv',
    bibliographic: '',
    name: 'Slovenian',
  },
  {
    alpha2: '',
    alpha3: 'sma',
    bibliographic: '',
    name: 'Southern Sami',
  },
  {
    alpha2: 'se',
    alpha3: 'sme',
    bibliographic: '',
    name: 'Northern Sami',
  },
  {
    alpha2: '',
    alpha3: 'smi',
    bibliographic: '',
    name: 'Sami languages',
  },
  {
    alpha2: '',
    alpha3: 'smj',
    bibliographic: '',
    name: 'Lule Sami',
  },
  {
    alpha2: '',
    alpha3: 'smn',
    bibliographic: '',
    name: 'Inari Sami',
  },
  {
    alpha2: 'sm',
    alpha3: 'smo',
    bibliographic: '',
    name: 'Samoan',
  },
  {
    alpha2: '',
    alpha3: 'sms',
    bibliographic: '',
    name: 'Skolt Sami',
  },
  {
    alpha2: 'sn',
    alpha3: 'sna',
    bibliographic: '',
    name: 'Shona',
  },
  {
    alpha2: 'sd',
    alpha3: 'snd',
    bibliographic: '',
    name: 'Sindhi',
  },
  {
    alpha2: '',
    alpha3: 'snk',
    bibliographic: '',
    name: 'Soninke',
  },
  {
    alpha2: '',
    alpha3: 'sog',
    bibliographic: '',
    name: 'Sogdian',
  },
  {
    alpha2: 'so',
    alpha3: 'som',
    bibliographic: '',
    name: 'Somali',
  },
  {
    alpha2: '',
    alpha3: 'son',
    bibliographic: '',
    name: 'Songhai languages',
  },
  {
    alpha2: 'st',
    alpha3: 'sot',
    bibliographic: '',
    name: 'Sotho, Southern',
  },
  {
    alpha2: 'es',
    alpha3: 'spa',
    bibliographic: '',
    name: 'Castilian',
  },
  {
    alpha2: 'es',
    alpha3: 'spa',
    bibliographic: '',
    name: 'Spanish',
  },
  {
    alpha2: 'sq',
    alpha3: 'sqi',
    bibliographic: 'alb',
    name: 'Albanian',
  },
  {
    alpha2: 'sc',
    alpha3: 'srd',
    bibliographic: '',
    name: 'Sardinian',
  },
  {
    alpha2: '',
    alpha3: 'srn',
    bibliographic: '',
    name: 'Sranan Tongo',
  },
  {
    alpha2: 'sr',
    alpha3: 'srp',
    bibliographic: '',
    name: 'Serbian',
  },
  {
    alpha2: '',
    alpha3: 'srr',
    bibliographic: '',
    name: 'Serer',
  },
  {
    alpha2: '',
    alpha3: 'ssa',
    bibliographic: '',
    name: 'Nilo-Saharan languages',
  },
  {
    alpha2: 'ss',
    alpha3: 'ssw',
    bibliographic: '',
    name: 'Swati',
  },
  {
    alpha2: '',
    alpha3: 'suk',
    bibliographic: '',
    name: 'Sukuma',
  },
  {
    alpha2: 'su',
    alpha3: 'sun',
    bibliographic: '',
    name: 'Sundanese',
  },
  {
    alpha2: '',
    alpha3: 'sus',
    bibliographic: '',
    name: 'Susu',
  },
  {
    alpha2: '',
    alpha3: 'sux',
    bibliographic: '',
    name: 'Sumerian',
  },
  {
    alpha2: 'sw',
    alpha3: 'swa',
    bibliographic: '',
    name: 'Swahili',
  },
  {
    alpha2: 'sv',
    alpha3: 'swe',
    bibliographic: '',
    name: 'Swedish',
  },
  {
    alpha2: '',
    alpha3: 'syc',
    bibliographic: '',
    name: 'Classical Syriac',
  },
  {
    alpha2: '',
    alpha3: 'syr',
    bibliographic: '',
    name: 'Syriac',
  },
  {
    alpha2: 'ty',
    alpha3: 'tah',
    bibliographic: '',
    name: 'Tahitian',
  },
  {
    alpha2: '',
    alpha3: 'tai',
    bibliographic: '',
    name: 'Tai languages',
  },
  {
    alpha2: 'ta',
    alpha3: 'tam',
    bibliographic: '',
    name: 'Tamil',
  },
  {
    alpha2: 'tt',
    alpha3: 'tat',
    bibliographic: '',
    name: 'Tatar',
  },
  {
    alpha2: 'te',
    alpha3: 'tel',
    bibliographic: '',
    name: 'Telugu',
  },
  {
    alpha2: '',
    alpha3: 'tem',
    bibliographic: '',
    name: 'Timne',
  },
  {
    alpha2: '',
    alpha3: 'ter',
    bibliographic: '',
    name: 'Tereno',
  },
  {
    alpha2: '',
    alpha3: 'tet',
    bibliographic: '',
    name: 'Tetum',
  },
  {
    alpha2: 'tg',
    alpha3: 'tgk',
    bibliographic: '',
    name: 'Tajik',
  },
  {
    alpha2: 'tl',
    alpha3: 'tgl',
    bibliographic: '',
    name: 'Tagalog',
  },
  {
    alpha2: 'th',
    alpha3: 'tha',
    bibliographic: '',
    name: 'Thai',
  },
  {
    alpha2: '',
    alpha3: 'tig',
    bibliographic: '',
    name: 'Tigre',
  },
  {
    alpha2: 'ti',
    alpha3: 'tir',
    bibliographic: '',
    name: 'Tigrinya',
  },
  {
    alpha2: '',
    alpha3: 'tiv',
    bibliographic: '',
    name: 'Tiv',
  },
  {
    alpha2: '',
    alpha3: 'tkl',
    bibliographic: '',
    name: 'Tokelau',
  },
  {
    alpha2: '',
    alpha3: 'tlh',
    bibliographic: '',
    name: 'Klingon',
  },
  {
    alpha2: '',
    alpha3: 'tlh',
    bibliographic: '',
    name: 'tlhIngan-Hol',
  },
  {
    alpha2: '',
    alpha3: 'tli',
    bibliographic: '',
    name: 'Tlingit',
  },
  {
    alpha2: '',
    alpha3: 'tmh',
    bibliographic: '',
    name: 'Tamashek',
  },
  {
    alpha2: '',
    alpha3: 'tog',
    bibliographic: '',
    name: 'Tonga (Nyasa)',
  },
  {
    alpha2: 'to',
    alpha3: 'ton',
    bibliographic: '',
    name: 'Tonga (Tonga Islands)',
  },
  {
    alpha2: '',
    alpha3: 'tpi',
    bibliographic: '',
    name: 'Tok Pisin',
  },
  {
    alpha2: '',
    alpha3: 'tsi',
    bibliographic: '',
    name: 'Tsimshian',
  },
  {
    alpha2: 'tn',
    alpha3: 'tsn',
    bibliographic: '',
    name: 'Tswana',
  },
  {
    alpha2: 'ts',
    alpha3: 'tso',
    bibliographic: '',
    name: 'Tsonga',
  },
  {
    alpha2: 'tk',
    alpha3: 'tuk',
    bibliographic: '',
    name: 'Turkmen',
  },
  {
    alpha2: '',
    alpha3: 'tum',
    bibliographic: '',
    name: 'Tumbuka',
  },
  {
    alpha2: '',
    alpha3: 'tup',
    bibliographic: '',
    name: 'Tupi languages',
  },
  {
    alpha2: 'tr',
    alpha3: 'tur',
    bibliographic: '',
    name: 'Turkish',
  },
  {
    alpha2: '',
    alpha3: 'tut',
    bibliographic: '',
    name: 'Altaic languages',
  },
  {
    alpha2: '',
    alpha3: 'tvl',
    bibliographic: '',
    name: 'Tuvalu',
  },
  {
    alpha2: 'tw',
    alpha3: 'twi',
    bibliographic: '',
    name: 'Twi',
  },
  {
    alpha2: '',
    alpha3: 'tyv',
    bibliographic: '',
    name: 'Tuvinian',
  },
  {
    alpha2: '',
    alpha3: 'udm',
    bibliographic: '',
    name: 'Udmurt',
  },
  {
    alpha2: '',
    alpha3: 'uga',
    bibliographic: '',
    name: 'Ugaritic',
  },
  {
    alpha2: 'ug',
    alpha3: 'uig',
    bibliographic: '',
    name: 'Uighur',
  },
  {
    alpha2: 'ug',
    alpha3: 'uig',
    bibliographic: '',
    name: 'Uyghur',
  },
  {
    alpha2: 'uk',
    alpha3: 'ukr',
    bibliographic: '',
    name: 'Ukrainian',
  },
  {
    alpha2: '',
    alpha3: 'umb',
    bibliographic: '',
    name: 'Umbundu',
  },
  {
    alpha2: '',
    alpha3: 'und',
    bibliographic: '',
    name: 'Undetermined',
  },
  {
    alpha2: 'ur',
    alpha3: 'urd',
    bibliographic: '',
    name: 'Urdu',
  },
  {
    alpha2: 'uz',
    alpha3: 'uzb',
    bibliographic: '',
    name: 'Uzbek',
  },
  {
    alpha2: '',
    alpha3: 'vai',
    bibliographic: '',
    name: 'Vai',
  },
  {
    alpha2: 've',
    alpha3: 'ven',
    bibliographic: '',
    name: 'Venda',
  },
  {
    alpha2: 'vi',
    alpha3: 'vie',
    bibliographic: '',
    name: 'Vietnamese',
  },
  {
    alpha2: 'vo',
    alpha3: 'vol',
    bibliographic: '',
    name: 'Volapük',
  },
  {
    alpha2: '',
    alpha3: 'vot',
    bibliographic: '',
    name: 'Votic',
  },
  {
    alpha2: '',
    alpha3: 'wak',
    bibliographic: '',
    name: 'Wakashan languages',
  },
  {
    alpha2: '',
    alpha3: 'wal',
    bibliographic: '',
    name: 'Wolaitta',
  },
  {
    alpha2: '',
    alpha3: 'wal',
    bibliographic: '',
    name: 'Wolaytta',
  },
  {
    alpha2: '',
    alpha3: 'war',
    bibliographic: '',
    name: 'Waray',
  },
  {
    alpha2: '',
    alpha3: 'was',
    bibliographic: '',
    name: 'Washo',
  },
  {
    alpha2: '',
    alpha3: 'wen',
    bibliographic: '',
    name: 'Sorbian languages',
  },
  {
    alpha2: 'wa',
    alpha3: 'wln',
    bibliographic: '',
    name: 'Walloon',
  },
  {
    alpha2: 'wo',
    alpha3: 'wol',
    bibliographic: '',
    name: 'Wolof',
  },
  {
    alpha2: '',
    alpha3: 'xal',
    bibliographic: '',
    name: 'Kalmyk',
  },
  {
    alpha2: '',
    alpha3: 'xal',
    bibliographic: '',
    name: 'Oirat',
  },
  {
    alpha2: 'xh',
    alpha3: 'xho',
    bibliographic: '',
    name: 'Xhosa',
  },
  {
    alpha2: '',
    alpha3: 'yao',
    bibliographic: '',
    name: 'Yao',
  },
  {
    alpha2: '',
    alpha3: 'yap',
    bibliographic: '',
    name: 'Yapese',
  },
  {
    alpha2: 'yi',
    alpha3: 'yid',
    bibliographic: '',
    name: 'Yiddish',
  },
  {
    alpha2: 'yo',
    alpha3: 'yor',
    bibliographic: '',
    name: 'Yoruba',
  },
  {
    alpha2: '',
    alpha3: 'ypk',
    bibliographic: '',
    name: 'Yupik languages',
  },
  {
    alpha2: '',
    alpha3: 'zap',
    bibliographic: '',
    name: 'Zapotec',
  },
  {
    alpha2: '',
    alpha3: 'zbl',
    bibliographic: '',
    name: 'Bliss',
  },
  {
    alpha2: '',
    alpha3: 'zbl',
    bibliographic: '',
    name: 'Blissymbolics',
  },
  {
    alpha2: '',
    alpha3: 'zbl',
    bibliographic: '',
    name: 'Blissymbols',
  },
  {
    alpha2: '',
    alpha3: 'zen',
    bibliographic: '',
    name: 'Zenaga',
  },
  {
    alpha2: '',
    alpha3: 'zgh',
    bibliographic: '',
    name: 'Standard Moroccan Tamazight',
  },
  {
    alpha2: 'za',
    alpha3: 'zha',
    bibliographic: '',
    name: 'Chuang',
  },
  {
    alpha2: 'za',
    alpha3: 'zha',
    bibliographic: '',
    name: 'Zhuang',
  },
  {
    alpha2: 'zh',
    alpha3: 'zho',
    bibliographic: 'chi',
    name: 'Chinese',
  },
  {
    alpha2: '',
    alpha3: 'znd',
    bibliographic: '',
    name: 'Zande languages',
  },
  {
    alpha2: 'zu',
    alpha3: 'zul',
    bibliographic: '',
    name: 'Zulu',
  },
  {
    alpha2: '',
    alpha3: 'zun',
    bibliographic: '',
    name: 'Zuni',
  },
  {
    alpha2: '',
    alpha3: 'zxx',
    bibliographic: '',
    name: 'No linguistic content',
  },
  {
    alpha2: '',
    alpha3: 'zxx',
    bibliographic: '',
    name: 'Not applicable',
  },
  {
    alpha2: '',
    alpha3: 'zza',
    bibliographic: '',
    name: 'Dimili',
  },
  {
    alpha2: '',
    alpha3: 'zza',
    bibliographic: '',
    name: 'Dimli',
  },
  {
    alpha2: '',
    alpha3: 'zza',
    bibliographic: '',
    name: 'Kirdki',
  },
  {
    alpha2: '',
    alpha3: 'zza',
    bibliographic: '',
    name: 'Kirmanjki',
  },
  {
    alpha2: '',
    alpha3: 'zza',
    bibliographic: '',
    name: 'Zaza',
  },
  {
    alpha2: '',
    alpha3: 'zza',
    bibliographic: '',
    name: 'Zazaki',
  },
];

// https://github.com/flowcommerce/json-reference/blob/main/data/final/locales.json
export const localeData = [
  {
    id: 'af-NA',
    name: 'Afrikaans - Namibia',
    country: 'NAM',
    language: 'af',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'ak-GH',
    name: 'Akan - Ghana',
    country: 'GHA',
    language: 'ak',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'sq-AL',
    name: 'Albanian - Albania',
    country: 'ALB',
    language: 'sq',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'sq-XK',
    name: 'Albanian - Kosovo',
    country: 'RKS',
    language: 'sq',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'sq-MK',
    name: 'Albanian - North Macedonia',
    country: 'MKD',
    language: 'sq',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'am',
    name: 'Amharic - Armenia',
    country: 'ARM',
    language: 'am',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'am-ET',
    name: 'Amharic - Ethiopia',
    country: 'ETH',
    language: 'am',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'ar-DZ',
    name: 'Arabic - Algeria',
    country: 'DZA',
    language: 'ar',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'ar',
    name: 'Arabic - Argentina',
    country: 'ARG',
    language: 'ar',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'ar-BH',
    name: 'Arabic - Bahrain',
    country: 'BHR',
    language: 'ar',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'ar-TD',
    name: 'Arabic - Chad',
    country: 'TCD',
    language: 'ar',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'ar-KM',
    name: 'Arabic - Comoros',
    country: 'COM',
    language: 'ar',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'ar-DJ',
    name: 'Arabic - Djibouti',
    country: 'DJI',
    language: 'ar',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'ar-EG',
    name: 'Arabic - Egypt',
    country: 'EGY',
    language: 'ar',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'ar-IL',
    name: 'Arabic - Israel',
    country: 'ISR',
    language: 'ar',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'ar-JO',
    name: 'Arabic - Jordan',
    country: 'JOR',
    language: 'ar',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'ar-KE',
    name: 'Arabic - Kenya',
    country: 'KEN',
    language: 'ar',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'ar-KW',
    name: 'Arabic - Kuwait',
    country: 'KWT',
    language: 'ar',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'ar-LB',
    name: 'Arabic - Lebanon',
    country: 'LBN',
    language: 'ar',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'ar-LY',
    name: 'Arabic - Libya',
    country: 'LBY',
    language: 'ar',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'ar-MR',
    name: 'Arabic - Mauritania',
    country: 'MRT',
    language: 'ar',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'ar-MA',
    name: 'Arabic - Morocco',
    country: 'MAR',
    language: 'ar',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'ar-OM',
    name: 'Arabic - Oman',
    country: 'OMN',
    language: 'ar',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'ar-QA',
    name: 'Arabic - Qatar',
    country: 'QAT',
    language: 'ar',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'ar-SA',
    name: 'Arabic - Saudi Arabia',
    country: 'SAU',
    language: 'ar',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'ar-SO',
    name: 'Arabic - Somalia',
    country: 'SOM',
    language: 'ar',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'ar-TN',
    name: 'Arabic - Tunisia',
    country: 'TUN',
    language: 'ar',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'ar-AE',
    name: 'Arabic - United Arab Emirates',
    country: 'ARE',
    language: 'ar',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'ar-EH',
    name: 'Arabic - Western Sahara',
    country: 'ESH',
    language: 'ar',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'ar-YE',
    name: 'Arabic - Yemen',
    country: 'YEM',
    language: 'ar',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'hy-AM',
    name: 'Armenian - Armenia',
    country: 'ARM',
    language: 'hy',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'az',
    name: 'Azerbaijani - Azerbaijan',
    country: 'AZE',
    language: 'az',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'bm',
    name: 'Bambara - Bermuda',
    country: 'BMU',
    language: 'bm',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'be',
    name: 'Belarusian - Belgium',
    country: 'BEL',
    language: 'be',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'bn',
    name: 'Bengali - Brunei Darussalam',
    country: 'BRN',
    language: 'bn',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'bn-IN',
    name: 'Bengali - India',
    country: 'IND',
    language: 'bn',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'bs',
    name: 'Bosnian - Bahamas',
    country: 'BHS',
    language: 'bs',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'bg',
    name: 'Bulgarian - Bulgaria',
    country: 'BGR',
    language: 'bg',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'my',
    name: 'Burmese - Malaysia',
    country: 'MYS',
    language: 'my',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'ca-AD',
    name: 'Catalan - Andorra',
    country: 'AND',
    language: 'ca',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'ca',
    name: 'Catalan - Canada',
    country: 'CAN',
    language: 'ca',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'ca-ES',
    name: 'Catalan - Catalan',
    country: 'ESP',
    language: 'ca',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'ca-FR',
    name: 'Catalan - France',
    country: 'FRA',
    language: 'ca',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'ca-IT',
    name: 'Catalan - Italy',
    country: 'ITA',
    language: 'ca',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'zh-CN',
    name: 'Chinese - China',
    country: 'CHN',
    language: 'zh',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'zh-HK',
    name: 'Chinese - Hong Kong SAR',
    country: 'HKG',
    language: 'zh',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'zh-MO',
    name: 'Chinese - Macau SAR',
    country: 'MAC',
    language: 'zh',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'zh-SG',
    name: 'Chinese - Singapore',
    country: 'SGP',
    language: 'zh',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'zh-TW',
    name: 'Chinese - Taiwan',
    country: 'TWN',
    language: 'zh',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'hr-BA',
    name: 'Croatian - Bosnia and Herzegovina',
    country: 'BIH',
    language: 'hr',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'hr',
    name: 'Croatian - Croatia',
    country: 'HRV',
    language: 'hr',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'cs-CZ',
    name: 'Czech - Czechia',
    country: 'CZE',
    language: 'cs',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'da-DK',
    name: 'Danish - Denmark',
    country: 'DNK',
    language: 'da',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'da-FO',
    name: 'Danish - Faroe Islands',
    country: 'FRO',
    language: 'da',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'da-GL',
    name: 'Danish - Greenland',
    country: 'GRL',
    language: 'da',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'dv-MV',
    name: 'Divehi - Maldives',
    country: 'MDV',
    language: 'dv',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'nl-AW',
    name: 'Dutch - Aruba',
    country: 'ABW',
    language: 'nl',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'nl-BE',
    name: 'Dutch - Belgium',
    country: 'BEL',
    language: 'nl',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'nl-BQ',
    name: 'Dutch - Bonaire, Sint Eustatius and Saba',
    country: 'BES',
    language: 'nl',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'nl-CW',
    name: 'Dutch - Curaçao',
    country: 'CUW',
    language: 'nl',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'nl-SX',
    name: 'Dutch - Sint Maarten',
    country: 'SXM',
    language: 'nl',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'nl-SR',
    name: 'Dutch - Suriname',
    country: 'SUR',
    language: 'nl',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'nl',
    name: 'Dutch - The Netherlands',
    country: 'NLD',
    language: 'nl',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'dz',
    name: 'Dzongkha - Algeria',
    country: 'DZA',
    language: 'dz',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-AS',
    name: 'English - American Samoa',
    country: 'ASM',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-AI',
    name: 'English - Anguilla',
    country: 'AIA',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-AG',
    name: 'English - Antigua and Barbuda',
    country: 'ATG',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-AU',
    name: 'English - Australia',
    country: 'AUS',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-AT',
    name: 'English - Austria',
    country: 'AUT',
    language: 'en',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'en-BS',
    name: 'English - Bahamas',
    country: 'BHS',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-BB',
    name: 'English - Barbados',
    country: 'BRB',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-BE',
    name: 'English - Belgium',
    country: 'BEL',
    language: 'en',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'en-BZ',
    name: 'English - Belize',
    country: 'BLZ',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-BM',
    name: 'English - Bermuda',
    country: 'BMU',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-BO',
    name: 'English - Bolivia',
    country: 'BOL',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-BW',
    name: 'English - Botswana',
    country: 'BWA',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-IO',
    name: 'English - British Indian Ocean Territory',
    country: 'IOT',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-VG',
    name: 'English - British Virgin Islands',
    country: 'VGB',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-BI',
    name: 'English - Burundi',
    country: 'BDI',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-CM',
    name: 'English - Cameroon',
    country: 'CMR',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-CA',
    name: 'English - Canada',
    country: 'CAN',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-KY',
    name: 'English - Cayman Islands',
    country: 'CYM',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-CX',
    name: 'English - Christmas Island',
    country: 'CXR',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-CC',
    name: 'English - Cocos (Keeling) Islands',
    country: 'CCK',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-CK',
    name: 'English - Cook Islands',
    country: 'COK',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-CY',
    name: 'English - Cyprus',
    country: 'CYP',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-DK',
    name: 'English - Denmark',
    country: 'DNK',
    language: 'en',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'en-DM',
    name: 'English - Dominica',
    country: 'DMA',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-SZ',
    name: 'English - Eswatini',
    country: 'SWZ',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-FK',
    name: 'English - Falkland Islands',
    country: 'FLK',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-FJ',
    name: 'English - Fiji',
    country: 'FJI',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-FI',
    name: 'English - Finland',
    country: 'FIN',
    language: 'en',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'en-GM',
    name: 'English - Gambia',
    country: 'GMB',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-DE',
    name: 'English - Germany',
    country: 'DEU',
    language: 'en',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'en-GH',
    name: 'English - Ghana',
    country: 'GHA',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-GI',
    name: 'English - Gibraltar',
    country: 'GIB',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-GL',
    name: 'English - Greenland',
    country: 'GRL',
    language: 'en',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'en-GD',
    name: 'English - Grenada',
    country: 'GRD',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-GU',
    name: 'English - Guam',
    country: 'GUM',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-GG',
    name: 'English - Guernsey',
    country: 'GGY',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-GY',
    name: 'English - Guyana',
    country: 'GUY',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-HK',
    name: 'English - Hong Kong',
    country: 'HKG',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-IN',
    name: 'English - India',
    country: 'IND',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-IE',
    name: 'English - Ireland',
    country: 'IRL',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-IM',
    name: 'English - Isle of Man',
    country: 'IMN',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-IL',
    name: 'English - Israel',
    country: 'ISR',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-JM',
    name: 'English - Jamaica',
    country: 'JAM',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-JE',
    name: 'English - Jersey',
    country: 'JEY',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-KE',
    name: 'English - Kenya',
    country: 'KEN',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-KI',
    name: 'English - Kiribati',
    country: 'KIR',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-LS',
    name: 'English - Lesotho',
    country: 'LSO',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-LR',
    name: 'English - Liberia',
    country: 'LBR',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-MO',
    name: 'English - Macau',
    country: 'MAC',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-MG',
    name: 'English - Madagascar',
    country: 'MDG',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-MW',
    name: 'English - Malawi',
    country: 'MWI',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-MY',
    name: 'English - Malaysia',
    country: 'MYS',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-MT',
    name: 'English - Malta',
    country: 'MLT',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-MH',
    name: 'English - Marshall Islands',
    country: 'MHL',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-MU',
    name: 'English - Mauritius',
    country: 'MUS',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-FM',
    name: 'English - Micronesia',
    country: 'FSM',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-MS',
    name: 'English - Montserrat',
    country: 'MSR',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-NA',
    name: 'English - Namibia',
    country: 'NAM',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-NR',
    name: 'English - Nauru',
    country: 'NRU',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-NL',
    name: 'English - Netherlands',
    country: 'NLD',
    language: 'en',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'en-NZ',
    name: 'English - New Zealand',
    country: 'NZL',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-NG',
    name: 'English - Nigeria',
    country: 'NGA',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-NU',
    name: 'English - Niue',
    country: 'NIU',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-NF',
    name: 'English - Norfolk Island',
    country: 'NFK',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-MP',
    name: 'English - Northern Mariana Islands',
    country: 'MNP',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-PK',
    name: 'English - Pakistan',
    country: 'PAK',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-PW',
    name: 'English - Palau',
    country: 'PLW',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-PG',
    name: 'English - Papua New Guinea',
    country: 'PNG',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-PH',
    name: 'English - Philippines',
    country: 'PHL',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-PN',
    name: 'English - Pitcairn',
    country: 'PCN',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-PR',
    name: 'English - Puerto Rico',
    country: 'PRI',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-RW',
    name: 'English - Rwanda',
    country: 'RWA',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-SH',
    name: 'English - Saint Helena',
    country: 'SHN',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-KN',
    name: 'English - Saint Kitts and Nevis',
    country: 'KNA',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-LC',
    name: 'English - Saint Lucia',
    country: 'LCA',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-VC',
    name: 'English - Saint Vincent and the Grenadines',
    country: 'VCT',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-WS',
    name: 'English - Samoa',
    country: 'WSM',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-SC',
    name: 'English - Seychelles',
    country: 'SYC',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-SL',
    name: 'English - Sierra Leone',
    country: 'SLE',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-SG',
    name: 'English - Singapore',
    country: 'SGP',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-SX',
    name: 'English - Sint Maarten',
    country: 'SXM',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-SI',
    name: 'English - Slovenia',
    country: 'SVN',
    language: 'en',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'en-SB',
    name: 'English - Solomon Islands',
    country: 'SLB',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-ZA',
    name: 'English - South Africa',
    country: 'ZAF',
    language: 'en',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'en-SE',
    name: 'English - Sweden',
    country: 'SWE',
    language: 'en',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'en-CH',
    name: 'English - Switzerland',
    country: 'CHE',
    language: 'en',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'en-TK',
    name: 'English - Tokelau',
    country: 'TKL',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-TO',
    name: 'English - Tonga',
    country: 'TON',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-TT',
    name: 'English - Trinidad and Tobago',
    country: 'TTO',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-TC',
    name: 'English - Turks and Caicos Islands',
    country: 'TCA',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-TV',
    name: 'English - Tuvalu',
    country: 'TUV',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-UG',
    name: 'English - Uganda',
    country: 'UGA',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-GB',
    name: 'English - United Kingdom',
    country: 'GBR',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-TZ',
    name: 'English - United Republic of Tanzania',
    country: 'TZA',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-US',
    name: 'English - United States',
    country: 'USA',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-UM',
    name: 'English - United States Minor Outlying Islands',
    country: 'UMI',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-VI',
    name: 'English - United States Virgin Islands',
    country: 'VIR',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-VU',
    name: 'English - Vanuatu',
    country: 'VUT',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-ZM',
    name: 'English - Zambia',
    country: 'ZMB',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'en-ZW',
    name: 'English - Zimbabwe',
    country: 'ZWE',
    language: 'en',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'et-EE',
    name: 'Estonian - Estonia',
    country: 'EST',
    language: 'et',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'et',
    name: 'Estonian - Ethiopia',
    country: 'ETH',
    language: 'et',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'ee',
    name: 'Ewe - Estonia',
    country: 'EST',
    language: 'ee',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'ee-TG',
    name: 'Ewe - Togo',
    country: 'TGO',
    language: 'ee',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'fi',
    name: 'Finnish - Finland',
    country: 'FIN',
    language: 'fi',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-DZ',
    name: 'French - Algeria',
    country: 'DZA',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-BE',
    name: 'French - Belgium',
    country: 'BEL',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-BJ',
    name: 'French - Benin',
    country: 'BEN',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-BF',
    name: 'French - Burkina Faso',
    country: 'BFA',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-BI',
    name: 'French - Burundi',
    country: 'BDI',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-CM',
    name: 'French - Cameroon',
    country: 'CMR',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-CA',
    name: 'French - Canada',
    country: 'CAN',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-CF',
    name: 'French - Central African Republic',
    country: 'CAF',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-TD',
    name: 'French - Chad',
    country: 'TCD',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-KM',
    name: 'French - Comoros',
    country: 'COM',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-CG',
    name: 'French - Congo',
    country: 'COG',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-CI',
    name: "French - Côte d'Ivoire",
    country: 'CIV',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-CD',
    name: 'French - Democratic Republic of the Congo',
    country: 'COD',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-DJ',
    name: 'French - Djibouti',
    country: 'DJI',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-GQ',
    name: 'French - Equatorial Guinea',
    country: 'GNQ',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr',
    name: 'French - France',
    country: 'FRA',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-GF',
    name: 'French - French Guiana',
    country: 'GUF',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-PF',
    name: 'French - French Polynesia',
    country: 'PYF',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-GA',
    name: 'French - Gabon',
    country: 'GAB',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-GP',
    name: 'French - Guadeloupe',
    country: 'GLP',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-GN',
    name: 'French - Guinea',
    country: 'GIN',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-HT',
    name: 'French - Haiti',
    country: 'HTI',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-LU',
    name: 'French - Luxembourg',
    country: 'LUX',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'fr-MG',
    name: 'French - Madagascar',
    country: 'MDG',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-ML',
    name: 'French - Mali',
    country: 'MLI',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-MQ',
    name: 'French - Martinique',
    country: 'MTQ',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-MR',
    name: 'French - Mauritania',
    country: 'MRT',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-MU',
    name: 'French - Mauritius',
    country: 'MUS',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-YT',
    name: 'French - Mayotte',
    country: 'MYT',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-MC',
    name: 'French - Monaco',
    country: 'MCO',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-MA',
    name: 'French - Morocco',
    country: 'MAR',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'fr-NC',
    name: 'French - New Caledonia',
    country: 'NCL',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-NE',
    name: 'French - Niger',
    country: 'NER',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-RW',
    name: 'French - Rwanda',
    country: 'RWA',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-RE',
    name: 'French - Réunion',
    country: 'REU',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-BL',
    name: 'French - Saint Barthélemy',
    country: 'BLM',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-MF',
    name: 'French - Saint Martin',
    country: 'MAF',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-PM',
    name: 'French - Saint Pierre and Miquelon',
    country: 'SPM',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-SN',
    name: 'French - Senegal',
    country: 'SEN',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-SC',
    name: 'French - Seychelles',
    country: 'SYC',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-CH',
    name: 'French - Switzerland',
    country: 'CHE',
    language: 'fr',
    numbers: {
      decimal: '.',
      group: ' ',
    },
  },
  {
    id: 'fr-TG',
    name: 'French - Togo',
    country: 'TGO',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-TN',
    name: 'French - Tunisia',
    country: 'TUN',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-VU',
    name: 'French - Vanuatu',
    country: 'VUT',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'fr-WF',
    name: 'French - Wallis and Futuna Islands',
    country: 'WLF',
    language: 'fr',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'ff-CM',
    name: 'Fula - Cameroon',
    country: 'CMR',
    language: 'ff',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'ff-GN',
    name: 'Fula - Guinea',
    country: 'GIN',
    language: 'ff',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'ff-MR',
    name: 'Fula - Mauritania',
    country: 'MRT',
    language: 'ff',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'ka-GE',
    name: 'Georgian - Georgia',
    country: 'GEO',
    language: 'ka',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'de-AT',
    name: 'German - Austria',
    country: 'AUT',
    language: 'de',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'de-BE',
    name: 'German - Belgium',
    country: 'BEL',
    language: 'de',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'de',
    name: 'German - Germany',
    country: 'DEU',
    language: 'de',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'de-IT',
    name: 'German - Italy',
    country: 'ITA',
    language: 'de',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'de-LI',
    name: 'German - Liechtenstein',
    country: 'LIE',
    language: 'de',
    numbers: {
      decimal: '.',
      group: "'",
    },
  },
  {
    id: 'de-LU',
    name: 'German - Luxembourg',
    country: 'LUX',
    language: 'de',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'de-CH',
    name: 'German - Switzerland',
    country: 'CHE',
    language: 'de',
    numbers: {
      decimal: '.',
      group: "'",
    },
  },
  {
    id: 'el-CY',
    name: 'Greek - Cyprus',
    country: 'CYP',
    language: 'el',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'el-GR',
    name: 'Greek - Greece',
    country: 'GRC',
    language: 'el',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'gu',
    name: 'Gujarati - Guam',
    country: 'GUM',
    language: 'gu',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'ha-GH',
    name: 'Hausa - Ghana',
    country: 'GHA',
    language: 'ha',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'ha-NE',
    name: 'Hausa - Niger',
    country: 'NER',
    language: 'ha',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'he-IL',
    name: 'Hebrew - Israel',
    country: 'ISR',
    language: 'he',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'hu',
    name: 'Hungarian - Hungary',
    country: 'HUN',
    language: 'hu',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'is',
    name: 'Icelandic - Iceland',
    country: 'ISL',
    language: 'is',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'ig-NG',
    name: 'Igbo - Nigeria',
    country: 'NGA',
    language: 'ig',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'id',
    name: 'Indonesian - Indonesia',
    country: 'IDN',
    language: 'id',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'ga',
    name: 'Irish - Gabon',
    country: 'GAB',
    language: 'ga',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'it',
    name: 'Italian - Italy',
    country: 'ITA',
    language: 'it',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'it-SM',
    name: 'Italian - San Marino',
    country: 'SMR',
    language: 'it',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'it-CH',
    name: 'Italian - Switzerland',
    country: 'CHE',
    language: 'it',
    numbers: {
      decimal: '.',
      group: "'",
    },
  },
  {
    id: 'ja-JP',
    name: 'Japanese - Japan',
    country: 'JPN',
    language: 'ja',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'kk-KZ',
    name: 'Kazakh - Kazakhstan',
    country: 'KAZ',
    language: 'kk',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'km',
    name: 'Khmer - Comoros',
    country: 'COM',
    language: 'km',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'rw',
    name: 'Kinyarwanda - Rwanda',
    country: 'RWA',
    language: 'rw',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'rn-BI',
    name: 'Kirundi - Burundi',
    country: 'BDI',
    language: 'rn',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'ko-KP',
    name: "Korean - Democratic People's Republic of Korea",
    country: 'PRK',
    language: 'ko',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'ko-KR',
    name: 'Korean - Korea',
    country: 'KOR',
    language: 'ko',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'ky',
    name: 'Kyrgyz - Cayman Islands',
    country: 'CYM',
    language: 'ky',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'lo-LA',
    name: "Lao - Lao People's Democratic Republic",
    country: 'LAO',
    language: 'lo',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'lv',
    name: 'Latvian - Latvia',
    country: 'LVA',
    language: 'lv',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'lv-LV',
    name: 'Latvian - Latvia',
    country: 'LVA',
    language: 'lv',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'ln-AO',
    name: 'Lingala - Angola',
    country: 'AGO',
    language: 'ln',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'ln-CF',
    name: 'Lingala - Central African Republic',
    country: 'CAF',
    language: 'ln',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'ln-CG',
    name: 'Lingala - Congo',
    country: 'COG',
    language: 'ln',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'lt',
    name: 'Lithuanian - Lithuania',
    country: 'LTU',
    language: 'lt',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'lt-LT',
    name: 'Lithuanian - Lithuania',
    country: 'LTU',
    language: 'lt',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'lu',
    name: 'Luba-Katanga - Luxembourg',
    country: 'LUX',
    language: 'lu',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'lb',
    name: 'Luxembourgish - Lebanon',
    country: 'LBN',
    language: 'lb',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'mk',
    name: 'Macedonian (FYROM)',
    country: 'MKD',
    language: 'mk',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'mg',
    name: 'Malagasy - Madagascar',
    country: 'MDG',
    language: 'mg',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'ms-BN',
    name: 'Malay - Brunei',
    country: 'BRN',
    language: 'ms',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'ms',
    name: 'Malay - Montserrat',
    country: 'MSR',
    language: 'ms',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'ms-SG',
    name: 'Malay - Singapore',
    country: 'SGP',
    language: 'ms',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'mt',
    name: 'Maltese - Malta',
    country: 'MLT',
    language: 'mt',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'mn',
    name: 'Mongolian - Mongolia',
    country: 'MNG',
    language: 'mn',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'ne-IN',
    name: 'Nepali - India',
    country: 'IND',
    language: 'ne',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'ne-NP',
    name: 'Nepali - Nepal',
    country: 'NPL',
    language: 'ne',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'ne',
    name: 'Nepali - Niger',
    country: 'NER',
    language: 'ne',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'nb-NO',
    name: 'Norwegian (Bokmål) - Norway',
    country: 'NOR',
    language: 'nb',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'nn-NO',
    name: 'Norwegian (Nynorsk) - Norway',
    country: 'NOR',
    language: 'nn',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'nb-SJ',
    name: 'Norwegian Bokmål - Svalbard and Jan Mayen Islands',
    country: 'SJM',
    language: 'nb',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'pa',
    name: 'Panjabi - Panama',
    country: 'PAN',
    language: 'pa',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'fa-TJ',
    name: 'Persian - Tajikistan',
    country: 'TJK',
    language: 'fa',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'pl',
    name: 'Polish - Poland',
    country: 'POL',
    language: 'pl',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'pt-AO',
    name: 'Portuguese - Angola',
    country: 'AGO',
    language: 'pt',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'pt-BR',
    name: 'Portuguese - Brazil',
    country: 'BRA',
    language: 'pt',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'pt-CV',
    name: 'Portuguese - Cabo Verde',
    country: 'CPV',
    language: 'pt',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'pt-GQ',
    name: 'Portuguese - Equatorial Guinea',
    country: 'GNQ',
    language: 'pt',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'pt-GW',
    name: 'Portuguese - Guinea-Bissau',
    country: 'GNB',
    language: 'pt',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'pt-LU',
    name: 'Portuguese - Luxembourg',
    country: 'LUX',
    language: 'pt',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'pt-MO',
    name: 'Portuguese - Macau',
    country: 'MAC',
    language: 'pt',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'pt-MZ',
    name: 'Portuguese - Mozambique',
    country: 'MOZ',
    language: 'pt',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'pt',
    name: 'Portuguese - Portugal',
    country: 'PRT',
    language: 'pt',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'pt-ST',
    name: 'Portuguese - Sao Tome and Principe',
    country: 'STP',
    language: 'pt',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'pt-CH',
    name: 'Portuguese - Switzerland',
    country: 'CHE',
    language: 'pt',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'pt-TL',
    name: 'Portuguese - Timor-Leste',
    country: 'TLS',
    language: 'pt',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'qu-BO',
    name: 'Quechua - Bolivia',
    country: 'BOL',
    language: 'qu',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'qu-EC',
    name: 'Quechua - Ecuador',
    country: 'ECU',
    language: 'qu',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'ro-MD',
    name: 'Romanian - Republic of Moldova',
    country: 'MDA',
    language: 'ro',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'ro',
    name: 'Romanian - Romania',
    country: 'ROU',
    language: 'ro',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'rm-CH',
    name: 'Romansh - Switzerland',
    country: 'CHE',
    language: 'rm',
    numbers: {
      decimal: '.',
      group: '’',
    },
  },
  {
    id: 'ru-BY',
    name: 'Russian - Belarus',
    country: 'BLR',
    language: 'ru',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'ru-KZ',
    name: 'Russian - Kazakhstan',
    country: 'KAZ',
    language: 'ru',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'ru-KG',
    name: 'Russian - Kyrgyzstan',
    country: 'KGZ',
    language: 'ru',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'ru-MD',
    name: 'Russian - Republic of Moldova',
    country: 'MDA',
    language: 'ru',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'ru',
    name: 'Russian - Russia',
    country: 'RUS',
    language: 'ru',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'ru-UA',
    name: 'Russian - Ukraine',
    country: 'UKR',
    language: 'ru',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'sg',
    name: 'Sango - Singapore',
    country: 'SGP',
    language: 'sg',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'sr-BA',
    name: 'Serbian - Bosnia and Herzegovina',
    country: 'BIH',
    language: 'sr',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'sr-XK',
    name: 'Serbian - Kosovo',
    country: 'RKS',
    language: 'sr',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'sr-ME',
    name: 'Serbian - Montenegro',
    country: 'MNE',
    language: 'sr',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'sr-RS',
    name: 'Serbian - Serbia',
    country: 'SRB',
    language: 'sr',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'sn',
    name: 'Shona - Senegal',
    country: 'SEN',
    language: 'sn',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'si',
    name: 'Sinhala - Slovenia',
    country: 'SVN',
    language: 'si',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'sk',
    name: 'Slovak - Slovakia',
    country: 'SVK',
    language: 'sk',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'sl',
    name: 'Slovene - Sierra Leone',
    country: 'SLE',
    language: 'sl',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'so-DJ',
    name: 'Somali - Djibouti',
    country: 'DJI',
    language: 'so',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'so-ET',
    name: 'Somali - Ethiopia',
    country: 'ETH',
    language: 'so',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'so-KE',
    name: 'Somali - Kenya',
    country: 'KEN',
    language: 'so',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'so',
    name: 'Somali - Somalia',
    country: 'SOM',
    language: 'so',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'es-AR',
    name: 'Spanish - Argentina',
    country: 'ARG',
    language: 'es',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'es-BO',
    name: 'Spanish - Bolivia',
    country: 'BOL',
    language: 'es',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'es-BR',
    name: 'Spanish - Brazil',
    country: 'BRA',
    language: 'es',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'es-CL',
    name: 'Spanish - Chile',
    country: 'CHL',
    language: 'es',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'es-CO',
    name: 'Spanish - Colombia',
    country: 'COL',
    language: 'es',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'es-CR',
    name: 'Spanish - Costa Rica',
    country: 'CRI',
    language: 'es',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'es-CU',
    name: 'Spanish - Cuba',
    country: 'CUB',
    language: 'es',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'es-DO',
    name: 'Spanish - Dominican Republic',
    country: 'DOM',
    language: 'es',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'es-EC',
    name: 'Spanish - Ecuador',
    country: 'ECU',
    language: 'es',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'es-SV',
    name: 'Spanish - El Salvador',
    country: 'SLV',
    language: 'es',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'es-GQ',
    name: 'Spanish - Equatorial Guinea',
    country: 'GNQ',
    language: 'es',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'es-GT',
    name: 'Spanish - Guatemala',
    country: 'GTM',
    language: 'es',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'es-HN',
    name: 'Spanish - Honduras',
    country: 'HND',
    language: 'es',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'es-MX',
    name: 'Spanish - Mexico',
    country: 'MEX',
    language: 'es',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'es-NI',
    name: 'Spanish - Nicaragua',
    country: 'NIC',
    language: 'es',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'es-PA',
    name: 'Spanish - Panama',
    country: 'PAN',
    language: 'es',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'es-PY',
    name: 'Spanish - Paraguay',
    country: 'PRY',
    language: 'es',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'es-PE',
    name: 'Spanish - Peru',
    country: 'PER',
    language: 'es',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'es-PH',
    name: 'Spanish - Philippines',
    country: 'PHL',
    language: 'es',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'es-PR',
    name: 'Spanish - Puerto Rico',
    country: 'PRI',
    language: 'es',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'es',
    name: 'Spanish - Spain',
    country: 'ESP',
    language: 'es',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'es-US',
    name: 'Spanish - United States of America',
    country: 'USA',
    language: 'es',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'es-UY',
    name: 'Spanish - Uruguay',
    country: 'URY',
    language: 'es',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'es-VE',
    name: 'Spanish - Venezuela',
    country: 'VEN',
    language: 'es',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'sw-CD',
    name: 'Swahili - Democratic Republic of the Congo',
    country: 'COD',
    language: 'sw',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'sw-FI',
    name: 'Swahili - Finland',
    country: 'FIN',
    language: 'sw',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'sw-KE',
    name: 'Swahili - Kenya',
    country: 'KEN',
    language: 'sw',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'sw-SE',
    name: 'Swahili - Sweden',
    country: 'SWE',
    language: 'sw',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'sw-UG',
    name: 'Swahili - Uganda',
    country: 'UGA',
    language: 'sw',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'sv-FI',
    name: 'Swedish - Finland',
    country: 'FIN',
    language: 'sv',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'sv-SE',
    name: 'Swedish - Sweden',
    country: 'SWE',
    language: 'sv',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'sv-AX',
    name: 'Swedish - Åland Islands',
    country: 'ALA',
    language: 'sv',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'ta-MY',
    name: 'Tamil - Malaysia',
    country: 'MYS',
    language: 'ta',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'ta-SG',
    name: 'Tamil - Singapore',
    country: 'SGP',
    language: 'ta',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'ta-LK',
    name: 'Tamil - Sri Lanka',
    country: 'LKA',
    language: 'ta',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'te-IN',
    name: 'Telugu - India',
    country: 'IND',
    language: 'te',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'th',
    name: 'Thai - Thailand',
    country: 'THA',
    language: 'th',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'ti-ER',
    name: 'Tigrinya - Eritrea',
    country: 'ERI',
    language: 'ti',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'tr-CY',
    name: 'Turkish - Cyprus',
    country: 'CYP',
    language: 'tr',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'tr',
    name: 'Turkish - Turkey',
    country: 'TUR',
    language: 'tr',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'tk',
    name: 'Turkmen - Tokelau',
    country: 'TKL',
    language: 'tk',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'tk-TM',
    name: 'Turkmen - Turkmenistan',
    country: 'TKM',
    language: 'tk',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'uk-UA',
    name: 'Ukrainian - Ukraine',
    country: 'UKR',
    language: 'uk',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'ur-IN',
    name: 'Urdu - India',
    country: 'IND',
    language: 'ur',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'uz',
    name: 'Uzbek - Uzbekistan',
    country: 'UZB',
    language: 'uz',
    numbers: {
      decimal: ',',
      group: ' ',
    },
  },
  {
    id: 'vi-VN',
    name: 'Vietnamese - Vietnam',
    country: 'VNM',
    language: 'vi',
    numbers: {
      decimal: ',',
      group: '.',
    },
  },
  {
    id: 'cy',
    name: 'Welsh - Cyprus',
    country: 'CYP',
    language: 'cy',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'yo-BJ',
    name: 'Yoruba - Benin',
    country: 'BEN',
    language: 'yo',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
  {
    id: 'zu-ZA',
    name: 'Zulu - South Africa',
    country: 'ZAF',
    language: 'zu',
    numbers: {
      decimal: '.',
      group: ',',
    },
  },
].map((locale) => (locale.id.includes('-') ? locale : { ...locale, id: `${locale.id}-${locale.id.toUpperCase()}` }));
